// @ts-nocheck

export const SUPPORTED_LANGUAGES = ['PT', 'ES', 'EN'] as const;
export type UiLanguage = typeof SUPPORTED_LANGUAGES[number];

export const LANGUAGE_STORAGE_KEY = 'euforms.backofficeLanguage';
export const PUBLIC_LANGUAGE_SESSION_KEY = 'euforms.publicLanguage';

export const normalizeLanguage = (value: unknown, fallback: UiLanguage = 'PT'): UiLanguage => {
  const normalized = String(value ?? '').trim().toUpperCase();
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(normalized)
    ? normalized as UiLanguage
    : fallback;
};

const exactEN: Record<string, string> = {
  'Administrador': 'Administrator',
  'Administração': 'Administration',
  'Empresa': 'Company',
  'Utilizador': 'User',
  'Utilizadores': 'Users',
  'Equipa': 'Team',
  'Formulários': 'Forms',
  'Formulário': 'Form',
  'Formulário em modo demonstrativo': 'Form in demonstration mode',
  'Os pagamentos efetuados neste formulário são apenas para testes e não são pagamentos reais.': 'Payments made through this form are for testing only and are not real payments.',
  'Ambiente de testes — este formulário é apenas demonstrativo.': 'Test environment — this form is for demonstration purposes only.',
  'Respostas': 'Replies',
  'Resposta': 'Reply',
  'Dashboard': 'Dashboard',
  'A minha conta': 'My account',
  'Sair': 'Sign out',
  'Navegação principal': 'Main navigation',
  'Navegação móvel': 'Mobile navigation',
  'Abrir menu': 'Open menu',
  'Idioma': 'Language',
  'Idioma do backoffice': 'Backoffice language',
  'Idioma do formulário': 'Form language',
  'Português': 'Portuguese',
  'Espanhol': 'Spanish',
  'Inglês': 'English',
  'Automático': 'Automatic',
  'AUTO — browser e depois IP': 'AUTO — browser then IP',
  'Usar sempre Português': 'Always use Portuguese',
  'Usar sempre Espanhol': 'Always use Spanish',
  'Usar sempre Inglês': 'Always use English',
  'Editor': 'Editor',
  'Definições': 'Settings',
  'Upload Imagem': 'Upload image',
  'Marca e publicação': 'Brand and publishing',
  'Pagamentos e regras': 'Payments and rules',
  'Pagamentos, stock e regras': 'Payments, stock and rules',
  'Campos do formulário': 'Form fields',
  'Dados principais': 'Main details',
  'Nome do formulário': 'Form name',
  'Informação do formulário': 'Form information',
  'Data de expiração': 'Expiration date',
  'Remover data': 'Remove date',
  'Chave API': 'API key',
  'Pagamento': 'Payment',
  'Pagamentos': 'Payments',
  'Métodos de pagamento': 'Payment methods',
  'Numerário': 'Cash',
  'Multibanco': 'Multibanco',
  'MB WAY': 'MB WAY',
  'Cartão de Crédito': 'Credit Card',
  'Cartão de crédito': 'Credit card',
  'Google Pay': 'Google Pay',
  'Apple Pay': 'Apple Pay',
  'Pagamento rápido com a carteira Google.': 'Fast payment with Google Wallet.',
  'Pagamento rápido com a carteira Apple.': 'Fast payment with Apple Wallet.',
  'Registo manual do pagamento.': 'Manual payment record.',
  'Referência Multibanco com prazo opcional.': 'Multibanco reference with optional deadline.',
  'Pagamento rápido por telemóvel.': 'Fast mobile payment.',
  'Pagamento por cartão.': 'Card payment.',
  'Carrinho': 'Cart',
  'Qtd.': 'Qty.',
  'Pagamento seguro': 'Secure payment',
  'Conclua o pagamento no ambiente seguro da Eupago sem sair do formulário.': 'Complete your payment in Eupago’s secure environment without leaving the form.',
  'Introduza os dados do cartão no ambiente seguro da Eupago para concluir o pagamento.': 'Enter your card details in Eupago’s secure environment to complete the payment.',
  'Será encaminhado para o ambiente seguro da Eupago para concluir o pagamento.': 'You will be redirected to Eupago’s secure environment to complete the payment.',
  'Anterior': 'Previous',
  'Seguinte': 'Next',
  'Finalizar': 'Finish',
  'A Processar...': 'Processing...',
  'Guardar': 'Save',
  'A guardar...': 'Saving...',
  'A guardar…': 'Saving…',
  'Cancelar': 'Cancel',
  'Fechar': 'Close',
  'Eliminar': 'Delete',
  'Editar': 'Edit',
  'Criar': 'Create',
  'A criar...': 'Creating...',
  'A criar…': 'Creating…',
  'Pesquisar': 'Search',
  'Procurar': 'Search',
  'Nome': 'Name',
  'Email': 'Email',
  'Palavra-passe': 'Password',
  'Nova palavra-passe': 'New password',
  'Confirmar palavra-passe': 'Confirm password',
  'Confirmar nova palavra-passe': 'Confirm new password',
  'Alterar palavra-passe': 'Change password',
  'Conta e segurança': 'Account and security',
  'Tipo de conta': 'Account type',
  'Estado': 'Status',
  'Ações': 'Actions',
  'Ativo': 'Active',
  'Inativo': 'Inactive',
  'Pausado': 'Paused',
  'Pendente': 'Pending',
  'Pago': 'Paid',
  'Cancelado': 'Cancelled',
  'Expirado': 'Expired',
  'Reembolsado': 'Refunded',
  'Concluído': 'Completed',
  'Erro': 'Error',
  'Erro!': 'Error!',
  'Sucesso': 'Success',
  'Atenção': 'Attention',
  'Sim': 'Yes',
  'Não': 'No',
  'Sem nome': 'No name',
  'Sem email': 'No email',
  'Sem data': 'No date',
  'Sem imagem': 'No image',
  'Sem prazo': 'No deadline',
  'Com prazo': 'With deadline',
  'Ilimitado': 'Unlimited',
  'Limitado': 'Limited',
  'Limitado por tipo': 'Limited by type',
  'Stock disponível': 'Available stock',
  'Stock e quantidades': 'Stock and quantities',
  'Quantidade': 'Quantity',
  'Quantidade máxima': 'Maximum quantity',
  'Quantidade por resposta': 'Quantity per response',
  'Resumo': 'Summary',
  'Notificações': 'Notifications',
  'Localização': 'Location',
  'Ligação do Google Maps': 'Google Maps link',
  'Sincronizado': 'Synchronized',
  'Não sincronizado': 'Not synchronized',
  'Sincronização necessária': 'Synchronization required',
  'Ação necessária': 'Action required',
  'Webhooks 2.0': 'Webhooks 2.0',
  'Campos básicos': 'Basic fields',
  'Campo de Preço': 'Price field',
  'Campo de preço': 'Price field',
  'Campo de Doação': 'Donation field',
  'Caixa de Texto': 'Text box',
  'Caixa de Seleção': 'Selection box',
  'Caixa de Validação': 'Checkbox',
  'Caixa de Informação': 'Information box',
  'Caixa de Comentário': 'Comment box',
  'Título': 'Title',
  'Comentário': 'Comment',
  'Avaliação': 'Rating',
  'Resposta longa': 'Long answer',
  'Campo obrigatório': 'Required field',
  'Campo Obrigatório': 'Required field',
  'Pré-visualização': 'Preview',
  'Pré-Visualizar': 'Preview',
  'Publicação': 'Publishing',
  'Boas práticas': 'Best practices',
  'Referência': 'Reference',
  'Entidade': 'Entity',
  'Valor': 'Value',
  'Valor (€)': 'Value (€)',
  'Valor doado': 'Donated amount',
  'Total do pedido': 'Order total',
  'Total de respostas': 'Total replies',
  'Dados da referência': 'Reference details',
  'EMAIL PARA NOTIFICAÇÕES': 'EMAIL FOR NOTIFICATIONS',
  'Número de Telefone': 'Phone number',
  'Indicativo do país': 'Country calling code',
  'Insira o seu Email': 'Enter your email',
  'Formulário enviado com sucesso': 'Form submitted successfully',
  'A sua resposta foi registada. Pode fechar esta página em segurança.': 'Your reply was recorded. You may safely close this page.',
  'Aguardando aceitação do pagamento MB WAY': 'Waiting for MB WAY payment acceptance',
  'Recebemos o pagamento MB WAY': 'We received the MB WAY payment',
  'Bem-vindo de volta': 'Welcome back',
  'Dados protegidos': 'Protected data',
  'Gestão centralizada': 'Centralized management',
  'Lembrar email': 'Remember email',
  'Registar': 'Create account',
  'Conta criada com sucesso!': 'Account created successfully!',
  'Registo concluído': 'Registration completed',
  'Recuperar palavra-passe': 'Recover password',
  'Recuperação de acesso': 'Access recovery',
  'Segurança da conta': 'Account security',
  'Voltar aos formulários': 'Back to Forms',
  'Voltar à página inicial': 'Back to home page',
  'Começar agora': 'Get started',
  'Pronto para começar?': 'Ready to get started?',
  'Visão geral': 'Overview',
  'Centro de gestão': 'Management center',
  'A carregar…': 'Loading…',
  'A carregar elemento…': 'Loading element…',
  'A carregar equipa…': 'Loading team…',
  'Ainda não existem formulários': 'There are no forms yet',
  'Ainda não existem respostas': 'There are no replies yet',
  'Ainda não existem utilizadores.': 'There are no users yet.',
  'Adicionar utilizador': 'Add user',
  'Procurar por email': 'Search by email',
  'Procurar por email, conta ou função': 'Search by email, account or role',
  'Procurar por nome, email ou identificador': 'Search by name, email or identifier',
  'Procurar por nome, email, identificador ou método de pagamento': 'Search by name, email, identifier or payment method',
  'Procurar por identificador, estado, item ou resposta': 'Search by identifier, status, item or reply',
  'Responsável': 'Owner',
  'Responsável atualizado.': 'Owner updated.',
  'Abrir formulários': 'Open forms',
  'Ver informação': 'View information',
  'Pedido de contacto': 'Contact request',
  'Inscrição em workshop': 'Workshop registration',
  'Donativo': 'Donation',
  'Campanha de Donativos': 'Donation campaign',
  'Pedido de Contacto': 'Contact request',
  'O essencial para avançar.': 'Everything required to continue.',
  'Comunicação automática após pagamento.': 'Automatic communication after payment.',
  'Partilha facilmente a localização de um evento físico.': 'Easily share the location of a physical event.',
  'Opcional. No dia seguinte, o formulário deixa de aceitar acessos e respostas.': 'Optional. On the following day, the form stops accepting access and replies.',
  'Preenche o nome do formulário, a chave API e pelo menos um método de pagamento.': 'Fill in the form name, API key and at least one payment method.',
  'A data de fim não pode ser anterior à data de início.': 'The end date cannot be before the start date.',
  'Ocorreu um erro. Por favor tente novamente': 'An error occurred. Please try again',
  'Tomei conhecimento que a informação constante deste formulário é guardada e tratada pela Eupago e dou consentimento para tal.': 'I acknowledge that the information in this form is stored and processed by Eupago and I consent to this processing.',
  'Verifica os dados do formulário': 'Check the form details',
  'Confirme o valor antes de continuar.': 'Confirm the amount before continuing.',
  'Formulário indisponível': 'Form unavailable',
  'O formulário está temporariamente indisponível.': 'The form is temporarily unavailable.',
};

const exactES: Record<string, string> = {
  'Formulário em modo demonstrativo': 'Formulario en modo demostración',
  'Os pagamentos efetuados neste formulário são apenas para testes e não são pagamentos reais.': 'Los pagos realizados mediante este formulario son solo pruebas y no son pagos reales.',
  'Ambiente de testes — este formulário é apenas demonstrativo.': 'Entorno de pruebas — este formulario es solo una demostración.',
  'Administrador': 'Administrador',
  'Administração': 'Administración',
  'Empresa': 'Empresa',
  'Utilizador': 'Usuario',
  'Utilizadores': 'Usuarios',
  'Equipa': 'Equipo',
  'Formulários': 'Formularios',
  'Formulário': 'Formulario',
  'Respostas': 'Respuestas',
  'Resposta': 'Respuesta',
  'Dashboard': 'Panel',
  'A minha conta': 'Mi cuenta',
  'Sair': 'Cerrar sesión',
  'Navegação principal': 'Navegación principal',
  'Navegação móvel': 'Navegación móvil',
  'Abrir menu': 'Abrir menú',
  'Idioma': 'Idioma',
  'Idioma do backoffice': 'Idioma del backoffice',
  'Idioma do formulário': 'Idioma del formulario',
  'Português': 'Portugués',
  'Espanhol': 'Español',
  'Inglês': 'Inglés',
  'Automático': 'Automático',
  'AUTO — browser e depois IP': 'AUTO — navegador y después IP',
  'Usar sempre Português': 'Usar siempre portugués',
  'Usar sempre Espanhol': 'Usar siempre español',
  'Usar sempre Inglês': 'Usar siempre inglés',
  'Editor': 'Editor',
  'Definições': 'Configuración',
  'Upload Imagem': 'Subir imagen',
  'Marca e publicação': 'Marca y publicación',
  'Pagamentos e regras': 'Pagos y reglas',
  'Pagamentos, stock e regras': 'Pagos, stock y reglas',
  'Campos do formulário': 'Campos del formulario',
  'Dados principais': 'Datos principales',
  'Nome do formulário': 'Nombre del formulario',
  'Informação do formulário': 'Información del formulario',
  'Data de expiração': 'Fecha de caducidad',
  'Remover data': 'Eliminar fecha',
  'Chave API': 'Clave API',
  'Pagamento': 'Pago',
  'Pagamentos': 'Pagos',
  'Métodos de pagamento': 'Métodos de pago',
  'Numerário': 'Efectivo',
  'Multibanco': 'Multibanco',
  'MB WAY': 'MB WAY',
  'Cartão de Crédito': 'Tarjeta de crédito',
  'Cartão de crédito': 'Tarjeta de crédito',
  'Google Pay': 'Google Pay',
  'Apple Pay': 'Apple Pay',
  'Pagamento rápido com a carteira Google.': 'Pago rápido con Google Wallet.',
  'Pagamento rápido com a carteira Apple.': 'Pago rápido con Apple Wallet.',
  'Registo manual do pagamento.': 'Registro manual del pago.',
  'Referência Multibanco com prazo opcional.': 'Referencia Multibanco con plazo opcional.',
  'Pagamento rápido por telemóvel.': 'Pago rápido por móvil.',
  'Pagamento por cartão.': 'Pago con tarjeta.',
  'Carrinho': 'Carrito',
  'Qtd.': 'Cant.',
  'Pagamento seguro': 'Pago seguro',
  'Conclua o pagamento no ambiente seguro da Eupago sem sair do formulário.': 'Completa el pago en el entorno seguro de Eupago sin salir del formulario.',
  'Introduza os dados do cartão no ambiente seguro da Eupago para concluir o pagamento.': 'Introduce los datos de la tarjeta en el entorno seguro de Eupago para completar el pago.',
  'Será encaminhado para o ambiente seguro da Eupago para concluir o pagamento.': 'Serás redirigido al entorno seguro de Eupago para completar el pago.',
  'Anterior': 'Anterior',
  'Seguinte': 'Siguiente',
  'Finalizar': 'Finalizar',
  'A Processar...': 'Procesando...',
  'Guardar': 'Guardar',
  'A guardar...': 'Guardando...',
  'A guardar…': 'Guardando…',
  'Cancelar': 'Cancelar',
  'Fechar': 'Cerrar',
  'Eliminar': 'Eliminar',
  'Editar': 'Editar',
  'Criar': 'Crear',
  'A criar...': 'Creando...',
  'A criar…': 'Creando…',
  'Pesquisar': 'Buscar',
  'Procurar': 'Buscar',
  'Nome': 'Nombre',
  'Email': 'Email',
  'Palavra-passe': 'Contraseña',
  'Nova palavra-passe': 'Nueva contraseña',
  'Confirmar palavra-passe': 'Confirmar contraseña',
  'Confirmar nova palavra-passe': 'Confirmar nueva contraseña',
  'Alterar palavra-passe': 'Cambiar contraseña',
  'Conta e segurança': 'Cuenta y seguridad',
  'Tipo de conta': 'Tipo de cuenta',
  'Estado': 'Estado',
  'Ações': 'Acciones',
  'Ativo': 'Activo',
  'Inativo': 'Inactivo',
  'Pausado': 'Pausado',
  'Pendente': 'Pendiente',
  'Pago': 'Pagado',
  'Cancelado': 'Cancelado',
  'Expirado': 'Caducado',
  'Reembolsado': 'Reembolsado',
  'Concluído': 'Completado',
  'Erro': 'Error',
  'Erro!': '¡Error!',
  'Sucesso': 'Éxito',
  'Atenção': 'Atención',
  'Sim': 'Sí',
  'Não': 'No',
  'Sem nome': 'Sin nombre',
  'Sem email': 'Sin email',
  'Sem data': 'Sin fecha',
  'Sem imagem': 'Sin imagen',
  'Sem prazo': 'Sin plazo',
  'Com prazo': 'Con plazo',
  'Ilimitado': 'Ilimitado',
  'Limitado': 'Limitado',
  'Limitado por tipo': 'Limitado por tipo',
  'Stock disponível': 'Stock disponible',
  'Stock e quantidades': 'Stock y cantidades',
  'Quantidade': 'Cantidad',
  'Quantidade máxima': 'Cantidad máxima',
  'Quantidade por resposta': 'Cantidad por respuesta',
  'Resumo': 'Resumen',
  'Notificações': 'Notificaciones',
  'Localização': 'Ubicación',
  'Ligação do Google Maps': 'Enlace de Google Maps',
  'Sincronizado': 'Sincronizado',
  'Não sincronizado': 'No sincronizado',
  'Sincronização necessária': 'Sincronización necesaria',
  'Ação necessária': 'Acción necesaria',
  'Webhooks 2.0': 'Webhooks 2.0',
  'Campos básicos': 'Campos básicos',
  'Campo de Preço': 'Campo de precio',
  'Campo de preço': 'Campo de precio',
  'Campo de Doação': 'Campo de donación',
  'Caixa de Texto': 'Caja de texto',
  'Caixa de Seleção': 'Caja de selección',
  'Caixa de Validação': 'Casilla de verificación',
  'Caixa de Informação': 'Caja de información',
  'Caixa de Comentário': 'Caja de comentario',
  'Título': 'Título',
  'Comentário': 'Comentario',
  'Avaliação': 'Valoración',
  'Resposta longa': 'Respuesta larga',
  'Campo obrigatório': 'Campo obligatorio',
  'Campo Obrigatório': 'Campo obligatorio',
  'Pré-visualização': 'Vista previa',
  'Pré-Visualizar': 'Vista previa',
  'Publicação': 'Publicación',
  'Boas práticas': 'Buenas prácticas',
  'Referência': 'Referencia',
  'Entidade': 'Entidad',
  'Valor': 'Valor',
  'Valor (€)': 'Valor (€)',
  'Valor doado': 'Importe donado',
  'Total do pedido': 'Total del pedido',
  'Total de respostas': 'Total de respuestas',
  'Dados da referência': 'Datos de la referencia',
  'EMAIL PARA NOTIFICAÇÕES': 'EMAIL PARA NOTIFICACIONES',
  'Número de Telefone': 'Número de teléfono',
  'Indicativo do país': 'Prefijo del país',
  'Insira o seu Email': 'Introduzca su email',
  'Formulário enviado com sucesso': 'Formulario enviado correctamente',
  'A sua resposta foi registada. Pode fechar esta página em segurança.': 'Su respuesta ha sido registrada. Puede cerrar esta página con seguridad.',
  'Aguardando aceitação do pagamento MB WAY': 'Esperando la aceptación del pago MB WAY',
  'Recebemos o pagamento MB WAY': 'Hemos recibido el pago MB WAY',
  'Bem-vindo de volta': 'Bienvenido de nuevo',
  'Dados protegidos': 'Datos protegidos',
  'Gestão centralizada': 'Gestión centralizada',
  'Lembrar email': 'Recordar email',
  'Registar': 'Crear cuenta',
  'Conta criada com sucesso!': '¡Cuenta creada correctamente!',
  'Registo concluído': 'Registro completado',
  'Recuperar palavra-passe': 'Recuperar contraseña',
  'Recuperação de acesso': 'Recuperación de acceso',
  'Segurança da conta': 'Seguridad de la cuenta',
  'Voltar aos formulários': 'Volver a Formularios',
  'Voltar à página inicial': 'Volver a la página de inicio',
  'Começar agora': 'Empezar ahora',
  'Pronto para começar?': '¿Listo para empezar?',
  'Visão geral': 'Vista general',
  'Centro de gestão': 'Centro de gestión',
  'A carregar…': 'Cargando…',
  'A carregar elemento…': 'Cargando elemento…',
  'A carregar equipa…': 'Cargando equipo…',
  'Ainda não existem formulários': 'Todavía no hay formularios',
  'Ainda não existem respostas': 'Todavía no hay respuestas',
  'Ainda não existem utilizadores.': 'Todavía no hay usuarios.',
  'Adicionar utilizador': 'Añadir usuario',
  'Procurar por email': 'Buscar por email',
  'Procurar por email, conta ou função': 'Buscar por email, cuenta o función',
  'Procurar por nome, email ou identificador': 'Buscar por nombre, email o identificador',
  'Procurar por nome, email, identificador ou método de pagamento': 'Buscar por nombre, email, identificador o método de pago',
  'Procurar por identificador, estado, item ou resposta': 'Buscar por identificador, estado, elemento o respuesta',
  'Responsável': 'Responsable',
  'Responsável atualizado.': 'Responsable actualizado.',
  'Abrir formulários': 'Abrir formularios',
  'Ver informação': 'Ver información',
  'Pedido de contacto': 'Solicitud de contacto',
  'Inscrição em workshop': 'Inscripción en taller',
  'Donativo': 'Donación',
  'Campanha de Donativos': 'Campaña de donaciones',
  'Pedido de Contacto': 'Solicitud de contacto',
  'O essencial para avançar.': 'Lo esencial para continuar.',
  'Comunicação automática após pagamento.': 'Comunicación automática después del pago.',
  'Partilha facilmente a localização de um evento físico.': 'Comparte fácilmente la ubicación de un evento físico.',
  'Opcional. No dia seguinte, o formulário deixa de aceitar acessos e respostas.': 'Opcional. Al día siguiente, el formulario deja de aceptar accesos y respuestas.',
  'Preenche o nome do formulário, a chave API e pelo menos um método de pagamento.': 'Complete el nombre del formulario, la clave API y al menos un método de pago.',
  'A data de fim não pode ser anterior à data de início.': 'La fecha de fin no puede ser anterior a la fecha de inicio.',
  'Ocorreu um erro. Por favor tente novamente': 'Se produjo un error. Inténtelo de nuevo',
  'Tomei conhecimento que a informação constante deste formulário é guardada e tratada pela Eupago e dou consentimento para tal.': 'Reconozco que la información de este formulario es almacenada y tratada por Eupago y doy mi consentimiento para ello.',
  'Verifica os dados do formulário': 'Comprueba los datos del formulario',
  'Confirme o valor antes de continuar.': 'Confirme el importe antes de continuar.',
  'Formulário indisponível': 'Formulario no disponible',
  'O formulário está temporariamente indisponível.': 'El formulario no está disponible temporalmente.',
};

// Additional full-sentence coverage for IT-1188.
Object.assign(exactEN, {
  "Privacidade": "Privacy",
  "Guardar IP da resposta?": "Save the reply IP address?",
  "Remover o acesso de": "Remove access for",
  "O pagamento com MB WAY não é possível para valores superiores a 99.999€.": "MB WAY payments are not available for amounts over €99,999.",
  "O pagamento com Multibanco não é possível para valores superiores a 99.999€.": "Multibanco payments are not available for amounts over €99,999.",
  "O pagamento com Cartão de Crédito não é possível para valores superiores a 3.999€.": "Credit Card payments are not available for amounts over €3,999.",
  "O pagamento com Google Pay não é possível para valores superiores a 99.999€.": "Google Pay payments are not available for amounts over €99,999.",
  "Ideal para inscrições locais, eventos pagos ou formações.": "Ideal for local registrations, paid events or training sessions.",
  "Preencha os seus dados para reservar a sua inscrição.": "Fill in your details to reserve your registration.",
  "Para recolher contributos simples com MB WAY, Multibanco ou numerário.": "For collecting simple contributions by MB WAY, Multibanco or cash.",
  "Útil para pedidos, contactos comerciais ou formulários sem pagamento online.": "Useful for requests, business contacts or forms without online payment.",
  "Erro ao carregar formulários.": "Error loading forms.",
  "Erro ao criar formulário.": "Error creating form.",
  "Erro ao apagar formulário.": "Error deleting form.",
  "Não foi possível copiar para a área de transferência.": "Could not copy to the clipboard.",
  "Produto, bilhete ou inscrição": "Product, ticket or registration",
  "Nome, contacto, data e preço. Ideal para eventos locais.": "Name, contact, date and price. Ideal for local events.",
  "Campos simples para recolher nome, email e mensagem.": "Simple fields to collect name, email and a message.",
  "Adiciona pelo menos um campo ao formulário.": "Add at least one field to the form.",
  "O campo foi criado sem um identificador válido. A lista foi recarregada.": "The field was created without a valid identifier. The list was reloaded.",
  "Modelo criado. Agora podes editar cada campo e avançar para as definições.": "Template created. You can now edit each field and continue to settings.",
  "Introdução ao criador de formulários": "Introduction to the form builder",
  "Erro ao guardar": "Error saving",
  "Mover para cima": "Move up",
  "Mover para baixo": "Move down",
  "O formulário foi guardado com sucesso. A avançar para o upload da imagem...": "The form was saved successfully. Continuing to image upload...",
  "Ocorreu um erro ao atualizar o formulário. Por favor, tenta novamente.": "An error occurred while updating the form. Please try again.",
  "Informação que identifica o formulário e aparece para o utilizador.": "Information that identifies the form and is shown to the user.",
  "AUTO tenta primeiro o idioma do browser e, se não for PT, ES ou EN, usa o país inferido pelo IP do visitante.": "AUTO first tries the browser language and, if it is not PT, ES or EN, uses the visitor country inferred from the IP address.",
  "N.º de dias para pagamento": "Number of days for payment",
  "Limita o número máximo que uma pessoa pode escolher numa resposta.": "Limits the maximum number a person can select in one reply.",
  "Enviar email quando o pagamento for efetuado?": "Send an email when the payment is completed?",
  "Guarda IP apenas se for necessário.": "Store the IP address only when necessary.",
  "Mensagem ao utilizador": "Message to the user",
  "Não foi possível enviar a imagem para o backend. Tenta novamente.": "Could not send the image to the backend. Please try again.",
  "Consulte dados e pagamentos numa área centralizada e simples.": "View data and payments in one simple, centralized area.",
  "Inclua coordenadas e ajude os participantes a chegar ao destino.": "Add coordinates and help participants reach the destination.",
  "Ligue a sua conta Eupago à plataforma Formulários em poucos minutos.": "Connect your Eupago account to Forms in just a few minutes.",
  "Entre para gerir os seus formulários, respostas e pagamentos.": "Sign in to manage your forms, replies and payments.",
  "Ligue a sua conta Eupago e configure o acesso à plataforma Formulários em poucos passos.": "Connect your Eupago account and configure Forms access in a few steps.",
  "Reembolsado": "Refunded",
  "Pago": "Paid",
  "Pendente": "Pending",
  "Falhado": "Failed",
  "Cancelado": "Cancelled",
  "A aguardar pagamento": "Awaiting payment",
  "Pago — por preparar": "Paid — awaiting preparation",
  "Enviada": "Shipped",
  "Pagamento falhado": "Payment failed",
  "Reembolsada": "Refunded",
  "Não foi possível verificar os pagamentos. Confirma as credenciais da Eupago na tua conta.": "Could not verify payments. Check the Eupago credentials in your account.",
  "A verificar…": "Checking…",
  "Verificar pagamentos": "Check payments",
  "Valor totalmente reembolsado": "Fully refunded amount",
  "Opcional para MB WAY e cartão": "Optional for MB WAY and card",
  "Não foi possível carregar as credenciais.": "Could not load the credentials.",
  "Não foi possível carregar as credenciais da API Eupago.": "Could not load the Eupago API credentials.",
  "Não foi possível guardar as credenciais.": "Could not save the credentials.",
  "As credenciais da API Eupago foram guardadas com segurança.": "The Eupago API credentials were saved securely.",
  "Não foi possível guardar as credenciais da API Eupago.": "Could not save the Eupago API credentials.",
  "Guardar credenciais": "Save credentials",
  "Texto apresentado ao utilizador": "Text shown to the user",
  "Ex.: Preenche os dados abaixo para reservar o teu lugar.": "E.g.: Fill in the details below to reserve your place.",
  "O subtítulo aparece aqui para orientar o utilizador.": "The subtitle appears here to guide the user.",
  "Antes passava horas a criar formulários para a minha equipa de futebol amador se registar em eventos, a plataforma Formulários foi a melhor solução que podia ter encontrado!": "I used to spend hours creating forms for my amateur football team to register for events. Forms was the best solution I could have found!",
  "A plataforma Formulários facilitou tanto o meu trabalho que agora tenho tempo para fazer o que mais gosto como dormir a sesta ou aprender piano. Simples, rápido e seguro como todos os produtos Eupago.": "Forms made my work so much easier that I now have time for the things I enjoy most, like taking a nap or learning piano. Simple, fast and secure, like all Eupago products.",
  "Este valor será sugerido como doação ao utilizador, mas ele pode alterá-lo.": "This amount will be suggested as a donation, but the user can change it.",
  "Usado para envio de informação relacionada com pagamento.": "Used to send payment-related information.",
  "Valor numérico que será cobrado ao utilizador. Usa vírgula ou ponto como separador decimal.": "Numeric amount that will be charged to the user. Use a comma or dot as the decimal separator.",
  "Texto descritivo que será exibido no formulário. Ideal para instruções, informações ou blocos de conteúdo.": "Descriptive text shown on the form. Ideal for instructions, information or content blocks.",
  "Texto secundário exibido abaixo do título. Pode ser usado para descrição ou orientação.": "Secondary text shown below the title. It can be used for a description or guidance.",
  "Campos básicos": "Basic fields",
  "Débitos Diretos": "Direct Debits",
  "Duplicar campo": "Duplicate field",
  "Editar Elementos": "Edit Elements",
  "Editar Elemento": "Edit Element",
  "Campo de título": "Title field",
  "Números": "Numbers",
  "Valida formato de email.": "Validates the email format.",
  "Seleciona uma imagem antes de enviar.": "Select an image before uploading.",
  "Partilha instantânea": "Instant sharing",
  "Preencha todos os campos obrigatórios antes de continuar.": "Fill in all required fields before continuing.",
  "Guardar responsável": "Save owner",
  "Guardar alterações": "Save changes",
  "Não foi possível guardar o elemento.": "Could not save the element.",
  "Não foi possível guardar o elemento. Tenta novamente.": "Could not save the element. Please try again.",
  "Não foi possível guardar o campo. Tenta novamente.": "Could not save the field. Please try again.",
  "Adicione os seus métodos de pagamento com a Eupago e deixe o processo de pagamento connosco": "Add your Eupago payment methods and leave the payment process to us.",
  "Aceita apenas valores numéricos.": "Accepts numeric values only.",
  "Texto sugestivo que aparece dentro do campo antes de o utilizador escrever.": "Hint text shown inside the field before the user types.",
});

Object.assign(exactES, {
  "Privacidade": "Privacidad",
  "Guardar IP da resposta?": "¿Guardar la dirección IP de la respuesta?",
  "Remover o acesso de": "Eliminar acceso de",
  "O pagamento com MB WAY não é possível para valores superiores a 99.999€.": "Los pagos con MB WAY no están disponibles para importes superiores a 99.999 €.",
  "O pagamento com Multibanco não é possível para valores superiores a 99.999€.": "Los pagos con Multibanco no están disponibles para importes superiores a 99.999 €.",
  "O pagamento com Cartão de Crédito não é possível para valores superiores a 3.999€.": "Los pagos con Tarjeta de Crédito no están disponibles para importes superiores a 3.999 €.",
  "O pagamento com Google Pay não é possível para valores superiores a 99.999€.": "Los pagos con Google Pay no están disponibles para importes superiores a 99.999 €.",
  "Ideal para inscrições locais, eventos pagos ou formações.": "Ideal para inscripciones locales, eventos de pago o formaciones.",
  "Preencha os seus dados para reservar a sua inscrição.": "Complete sus datos para reservar su inscripción.",
  "Para recolher contributos simples com MB WAY, Multibanco ou numerário.": "Para recoger aportaciones sencillas con MB WAY, Multibanco o efectivo.",
  "Útil para pedidos, contactos comerciais ou formulários sem pagamento online.": "Útil para solicitudes, contactos comerciales o formularios sin pago online.",
  "Erro ao carregar formulários.": "Error al cargar los formularios.",
  "Erro ao criar formulário.": "Error al crear el formulario.",
  "Erro ao apagar formulário.": "Error al eliminar el formulario.",
  "Não foi possível copiar para a área de transferência.": "No se pudo copiar al portapapeles.",
  "Produto, bilhete ou inscrição": "Producto, entrada o inscripción",
  "Nome, contacto, data e preço. Ideal para eventos locais.": "Nombre, contacto, fecha y precio. Ideal para eventos locales.",
  "Campos simples para recolher nome, email e mensagem.": "Campos sencillos para recoger nombre, email y mensaje.",
  "Adiciona pelo menos um campo ao formulário.": "Añade al menos un campo al formulario.",
  "O campo foi criado sem um identificador válido. A lista foi recarregada.": "El campo se creó sin un identificador válido. La lista se volvió a cargar.",
  "Modelo criado. Agora podes editar cada campo e avançar para as definições.": "Plantilla creada. Ahora puedes editar cada campo y continuar a la configuración.",
  "Introdução ao criador de formulários": "Introducción al creador de formularios",
  "Erro ao guardar": "Error al guardar",
  "Mover para cima": "Mover hacia arriba",
  "Mover para baixo": "Mover hacia abajo",
  "O formulário foi guardado com sucesso. A avançar para o upload da imagem...": "El formulario se guardó correctamente. Continuando con la subida de la imagen...",
  "Ocorreu um erro ao atualizar o formulário. Por favor, tenta novamente.": "Se produjo un error al actualizar el formulario. Inténtalo de nuevo.",
  "Informação que identifica o formulário e aparece para o utilizador.": "Información que identifica el formulario y se muestra al usuario.",
  "AUTO tenta primeiro o idioma do browser e, se não for PT, ES ou EN, usa o país inferido pelo IP do visitante.": "AUTO prueba primero el idioma del navegador y, si no es PT, ES o EN, utiliza el país del visitante inferido a partir de su dirección IP.",
  "N.º de dias para pagamento": "N.º de días para el pago",
  "Limita o número máximo que uma pessoa pode escolher numa resposta.": "Limita el número máximo que una persona puede seleccionar en una respuesta.",
  "Enviar email quando o pagamento for efetuado?": "¿Enviar un email cuando se complete el pago?",
  "Guarda IP apenas se for necessário.": "Guarda la dirección IP solo cuando sea necesario.",
  "Mensagem ao utilizador": "Mensaje al usuario",
  "Não foi possível enviar a imagem para o backend. Tenta novamente.": "No se pudo enviar la imagen al backend. Inténtalo de nuevo.",
  "Consulte dados e pagamentos numa área centralizada e simples.": "Consulte datos y pagos en un área sencilla y centralizada.",
  "Inclua coordenadas e ajude os participantes a chegar ao destino.": "Añada coordenadas y ayude a los participantes a llegar al destino.",
  "Ligue a sua conta Eupago à plataforma Formulários em poucos minutos.": "Conecte su cuenta de Eupago con Formularios en pocos minutos.",
  "Entre para gerir os seus formulários, respostas e pagamentos.": "Inicie sesión para gestionar sus formularios, respuestas y pagos.",
  "Ligue a sua conta Eupago e configure o acesso à plataforma Formulários em poucos passos.": "Conecte su cuenta de Eupago y configure el acceso a Formularios en unos pocos pasos.",
  "Reembolsado": "Reembolsado",
  "Pago": "Pagado",
  "Pendente": "Pendiente",
  "Falhado": "Fallido",
  "Cancelado": "Cancelado",
  "A aguardar pagamento": "En espera de pago",
  "Pago — por preparar": "Pagado — pendiente de preparación",
  "Enviada": "Enviada",
  "Pagamento falhado": "Pago fallido",
  "Reembolsada": "Reembolsada",
  "Não foi possível verificar os pagamentos. Confirma as credenciais da Eupago na tua conta.": "No se pudieron verificar los pagos. Comprueba las credenciales de Eupago en tu cuenta.",
  "A verificar…": "Comprobando…",
  "Verificar pagamentos": "Comprobar pagos",
  "Valor totalmente reembolsado": "Importe totalmente reembolsado",
  "Opcional para MB WAY e cartão": "Opcional para MB WAY y tarjeta",
  "Não foi possível carregar as credenciais.": "No se pudieron cargar las credenciales.",
  "Não foi possível carregar as credenciais da API Eupago.": "No se pudieron cargar las credenciales de la API de Eupago.",
  "Não foi possível guardar as credenciais.": "No se pudieron guardar las credenciales.",
  "As credenciais da API Eupago foram guardadas com segurança.": "Las credenciales de la API de Eupago se guardaron de forma segura.",
  "Não foi possível guardar as credenciais da API Eupago.": "No se pudieron guardar las credenciales de la API de Eupago.",
  "Guardar credenciais": "Guardar credenciales",
  "Texto apresentado ao utilizador": "Texto mostrado al usuario",
  "Ex.: Preenche os dados abaixo para reservar o teu lugar.": "Ej.: Completa los datos siguientes para reservar tu plaza.",
  "O subtítulo aparece aqui para orientar o utilizador.": "El subtítulo aparece aquí para orientar al usuario.",
  "Antes passava horas a criar formulários para a minha equipa de futebol amador se registar em eventos, a plataforma Formulários foi a melhor solução que podia ter encontrado!": "Antes pasaba horas creando formularios para que mi equipo de fútbol amateur se inscribiera en eventos. ¡Formularios fue la mejor solución que podía haber encontrado!",
  "A plataforma Formulários facilitou tanto o meu trabalho que agora tenho tempo para fazer o que mais gosto como dormir a sesta ou aprender piano. Simples, rápido e seguro como todos os produtos Eupago.": "Formularios facilitó tanto mi trabajo que ahora tengo tiempo para hacer lo que más me gusta, como dormir la siesta o aprender piano. Sencillo, rápido y seguro, como todos los productos de Eupago.",
  "Este valor será sugerido como doação ao utilizador, mas ele pode alterá-lo.": "Este importe se sugerirá como donación, pero el usuario puede modificarlo.",
  "Usado para envio de informação relacionada com pagamento.": "Se utiliza para enviar información relacionada con el pago.",
  "Valor numérico que será cobrado ao utilizador. Usa vírgula ou ponto como separador decimal.": "Importe numérico que se cobrará al usuario. Use coma o punto como separador decimal.",
  "Texto descritivo que será exibido no formulário. Ideal para instruções, informações ou blocos de conteúdo.": "Texto descriptivo que se mostrará en el formulario. Ideal para instrucciones, información o bloques de contenido.",
  "Texto secundário exibido abaixo do título. Pode ser usado para descrição ou orientação.": "Texto secundario mostrado debajo del título. Puede utilizarse como descripción u orientación.",
  "Campos básicos": "Campos básicos",
  "Débitos Diretos": "Débitos Directos",
  "Duplicar campo": "Duplicar campo",
  "Editar Elementos": "Editar elementos",
  "Editar Elemento": "Editar elemento",
  "Campo de título": "Campo de título",
  "Números": "Números",
  "Valida formato de email.": "Valida el formato del email.",
  "Seleciona uma imagem antes de enviar.": "Selecciona una imagen antes de enviarla.",
  "Partilha instantânea": "Compartir al instante",
  "Preencha todos os campos obrigatórios antes de continuar.": "Complete todos los campos obligatorios antes de continuar.",
  "Guardar responsável": "Guardar responsable",
  "Guardar alterações": "Guardar cambios",
  "Não foi possível guardar o elemento.": "No se pudo guardar el elemento.",
  "Não foi possível guardar o elemento. Tenta novamente.": "No se pudo guardar el elemento. Inténtalo de nuevo.",
  "Não foi possível guardar o campo. Tenta novamente.": "No se pudo guardar el campo. Inténtalo de nuevo.",
  "Adicione os seus métodos de pagamento com a Eupago e deixe o processo de pagamento connosco": "Añada sus métodos de pago de Eupago y deje el proceso de pago en nuestras manos.",
  "Aceita apenas valores numéricos.": "Solo acepta valores numéricos.",
  "Texto sugestivo que aparece dentro do campo antes de o utilizador escrever.": "Texto de ayuda que aparece dentro del campo antes de que el usuario escriba.",
});



// Audited UI coverage across every scene and reusable component for IT-1188.
// Exact sentence translations take precedence over the word-level fallback to avoid mixed-language UI.
Object.assign(exactEN, {
  "(Sugestão:": "(Suggestion:",
  "+ Produto / bilhete com preço": "+ Product / ticket with price",
  "- Eupago - Instituição de Pagamento": "- Eupago - Payment Institution",
  ". Ele será marcado como apagado e deixará de aparecer nesta lista.": ". It will be marked as deleted and will no longer appear in this list.",
  ". O código do seu registo é o seguinte:": ". Your registration code is:",
  "A carregar credenciais...": "Loading credentials...",
  "A chave criptográfica pode ter sido alterada na Eupago. Sincroniza este formulário para voltar a receber estados de pagamento.": "The cryptographic key may have changed at Eupago. Synchronize this form to resume receiving payment statuses.",
  "A criar modelo. Aguarda um instante...": "Creating template. Please wait a moment...",
  "A imagem é opcional. Quando estiver tudo pronto, finaliza e regressa à lista de formulários.": "The image is optional. When everything is ready, finish and return to the forms list.",
  "A infraestrutura Eupago protege os dados e os pagamentos.": "Eupago's infrastructure protects data and payments.",
  "Abre cada resposta para consultar os campos preenchidos e os itens correspondentes.": "Open each reply to view the completed fields and corresponding items.",
  "adiciona um campo, usa o lápis para o configurar e confirma o estado à direita antes de avançar. Todas as ações são guardadas automaticamente.": "add a field, use the pencil to configure it and check its status on the right before continuing. All actions are saved automatically.",
  "Adicione um elemento para prosseguir.": "Add an element to continue.",
  "Ainda não existem formulários.": "There are no forms yet.",
  "Ainda não tens campos de preço para aplicar stock por tipo.": "You do not yet have price fields to apply stock by type.",
  "Ainda não tens campos de preço para limitar por tipo.": "You do not yet have price fields to limit by type.",
  "Após ver a necessidade real dos clientes Eupago de criarem formulários para os seus eventos onde pudessem incorporar métodos de pagamento. Surgiu a ideia de criar um sistema simples e eficaz que pudesse incorporar tudo isto num só local e daí nasceu a plataforma Formulários.": "After seeing Eupago customers' real need to create forms for events with integrated payment methods, the idea arose to build a simple and effective system that could bring everything together in one place. That is how Forms was born.",
  "Arrasta para ordenar. Usa o lápis para editar cada campo.": "Drag to reorder. Use the pencil to edit each field.",
  "Arrasta uma imagem para aqui": "Drag an image here",
  "Arraste uma imagem para aqui": "Drag an image here",
  "As respostas aparecem aqui depois de um cliente concluir o formulário público.": "Replies appear here after a customer completes the public form.",
  "Atalhos rápidos": "Quick shortcuts",
  "Ativa esta opção quando a resposta for necessária para concluir o formulário.": "Enable this option when a reply is required to complete the form.",
  "Ativar": "Activate",
  "Ativar conta?": "Activate account?",
  "Campo de texto curto": "Short text field",
  "Campo duplicado e guardado.": "Field duplicated and saved.",
  "Campo removido. Usa “Desfazer” se foi por engano.": "Field removed. Use “Undo” if this was a mistake.",
  "Campo restaurado com sucesso.": "Field restored successfully.",
  "Campo sem identificador": "Field without an identifier",
  "Campos preenchidos": "Completed fields",
  "Cancelar seleção": "Cancel selection",
  "Chave de produção": "Production key",
  "Clica para adicionar ao formulário": "Click to add to the form",
  "Coloque uma componente do tipo Campo de Preço ou Doação, antes de finalizar.": "Add a Price or Donation field before finishing.",
  "Com a plataforma Formulários consiga criar os seus formulários de forma simples e rápida integrando diretamente com os seus métodos de pagamentos na Eupago": "With Forms you can create forms quickly and easily, integrating them directly with your Eupago payment methods.",
  "Comece a criar formulários": "Start creating forms",
  "Começa por um modelo ou adiciona campos manualmente. O utilizador vê a pré-visualização ao centro.": "Start with a template or add fields manually. The user sees the preview in the center.",
  "Começar vazio": "Start blank",
  "Conceda este perfil apenas a pessoas autorizadas a gerir toda a plataforma.": "Grant this profile only to people authorized to manage the entire platform.",
  "Configure o conteúdo e confirme o resultado na pré-visualização.": "Configure the content and check the result in the preview.",
  "Confirmamos que recebemos os dados que inseriu referente à sua compra no": "We confirm that we received the information you entered for your purchase at",
  "Consulte os dados da sua conta, mantenha o acesso protegido e gira as credenciais da API Eupago.": "View your account details, keep access secure and manage your Eupago API credentials.",
  "Continuar para o login": "Continue to login",
  "Controla disponibilidade total ou por produto/preço.": "Control total availability or availability by product/price.",
  "Controla se o campo é obrigatório e que tipo de dado pode ser introduzido.": "Control whether the field is required and what type of data can be entered.",
  "Copiar dados de pagamento": "Copy payment details",
  "Copiar ID": "Copy ID",
  "Copiar identificador": "Copy identifier",
  "Copiar Identificador": "Copy Identifier",
  "Copiar URL": "Copy URL",
  "Credenciais da API Eupago": "Eupago API credentials",
  "Cria o primeiro formulário e começa com um modelo simples para o utilizador não ficar perdido no editor.": "Create your first form and start with a simple template so the user can get started easily in the editor.",
  "Criador de formulários": "Form builder",
  "Criar conta gratuita": "Create free account",
  "Crie acessos USER para os colaboradores e remova os que já não precisam de entrar.": "Create USER access for team members and remove access for those who no longer need it.",
  "Crie experiências profissionais, recolha respostas e receba pagamentos através de uma plataforma simples, integrada diretamente com a Eupago.": "Create professional experiences, collect replies and receive payments through a simple platform integrated directly with Eupago.",
  "Crie, publique e acompanhe respostas sem processos complicados.": "Create, publish and track replies without complicated processes.",
  "Crie, publique e receba pagamentos num só lugar.": "Create, publish and receive payments in one place.",
  "Data inicial": "Start date",
  "Define a legenda, o texto de ajuda, a obrigatoriedade e a validação deste campo.": "Define the label, help text, required status and validation for this field.",
  "Define o idioma da experiência pública sem alterar o idioma do backoffice.": "Set the language of the public experience without changing the backoffice language.",
  "devolver o acesso a": "restore access to",
  "Disponível para reembolso": "Available for refund",
  "Enviado email com o link de recuperar palavra-passe": "An email with the password recovery link has been sent",
  "Escolha o que pretende fazer com “": "Choose what you want to do with “",
  "Escolha os artigos e as quantidades.": "Choose the items and quantities.",
  "Escolha uma palavra-passe forte e diferente das que utilizou anteriormente.": "Choose a strong password that is different from passwords you have used before.",
  "Escolhe como o campo deve validar os dados introduzidos, por exemplo email, número ou NIF.": "Choose how the field should validate entered data, for example email, number or tax ID.",
  "Escolhe um modelo ou preenche só o essencial. Depois editas os campos no construtor visual.": "Choose a template or fill in only the essentials. You can then edit the fields in the visual builder.",
  "Escolhe validação quando queres evitar respostas inválidas.": "Choose validation when you want to prevent invalid replies.",
  "Escreve o valor desejado e clica no ícone": "Enter the desired value and click the icon",
  "Esqueceu-se da palavra-passe?": "Forgot your password?",
  "Esta ação remove o formulário e deixa de o disponibilizar aos clientes.": "This action removes the form and makes it unavailable to customers.",
  "Estas credenciais serão utilizadas para gerir as integrações de todos os seus formulários.": "These credentials will be used to manage integrations for all your forms.",
  "Este bloco serve para criar separadores, introduções ou cabeçalhos dentro do formulário.": "Use this block to create dividers, introductions or headings within the form.",
  "Este campo não tem identificador válido.": "This field does not have a valid identifier.",
  "Este formulário não está disponível de momento. Por favor, tente novamente mais tarde.": "This form is currently unavailable. Please try again later.",
  "Estes textos aparecem no formulário público e ajudam o utilizador a preencher corretamente.": "These texts appear on the public form and help the user complete it correctly.",
  "está a solicitar um pagamento através da Instituição de Pagamento Eupago Lda.": "is requesting a payment through Eupago Lda., a Payment Institution.",
  "Está pronto para configurares pagamentos, stock e publicação.": "It is ready for you to configure payments, stock and publishing.",
  "Eupago. Todos os direitos reservados.": "Eupago. All rights reserved.",
  "Evita duplicar texto que já aparece noutros campos.": "Avoid duplicating text that already appears in other fields.",
  "Evita o ecrã vazio: escolhe um ponto de partida e depois ajusta os campos ao teu caso.": "Avoid an empty screen: choose a starting point and then adjust the fields to your case.",
  "Evita repetir texto que já aparece noutros campos.": "Avoid repeating text that already appears in other fields.",
  "Evita texto pequeno dentro da imagem.": "Avoid small text inside the image.",
  "Ex.: Escreve aqui o teu nome": "E.g.: Enter your name here",
  "Ex.: Nome completo": "E.g.: Full name",
  "Exemplo: Por motivos de segurança, o seu IP será guardado.": "Example: For security reasons, your IP address will be stored.",
  "Existem alterações por guardar.": "There are unsaved changes.",
  "Experimente alterar os termos da pesquisa.": "Try changing the search terms.",
  "Ferramentas práticas, segurança Eupago e uma experiência pensada para equipas de qualquer dimensão.": "Practical tools, Eupago security and an experience designed for teams of any size.",
  "Ficheiro escolhido": "Selected file",
  "Formulário apagado.": "Form deleted.",
  "Formulários e pagamentos com tecnologia Eupago.": "Forms and payments powered by Eupago technology.",
  "Formulários existentes na plataforma": "Forms on the platform",
  "Formulários geridos": "Managed forms",
  "Formulários inteligentes.": "Smart forms.",
  "Formulários que trabalham por si": "Forms that work for you",
  "Formulários recentes": "Recent forms",
  "Gerir, editar e publicar formulários": "Manage, edit and publish forms",
  "Guarda primeiro a nova Chave API antes de sincronizar.": "Save the new API key before synchronizing.",
  "Idioma do backoffice": "Backoffice language",
  "Imagem pronta para envio.": "Image ready to upload.",
  "Impede o envio sem resposta.": "Prevents submission without a reply.",
  "Inativar conta?": "Deactivate account?",
  "Indique o email associado à sua conta. Enviaremos um link seguro válido durante 15 minutos.": "Enter the email associated with your account. We will send a secure link valid for 15 minutes.",
  "Introduz um valor de reembolso válido.": "Enter a valid refund amount.",
  "Já tenho conta": "I already have an account",
  "Larga a imagem aqui": "Drop the image here",
  "Largue aqui a sua imagem": "Drop your image here",
  "Limite de Referências Pagas?": "Paid references limit?",
  "Marca como obrigatório apenas o que for mesmo necessário.": "Mark only what is truly necessary as required.",
  "MB WAY, Multibanco e cartão diretamente nos seus formulários.": "MB WAY, Multibanco and card payments directly in your forms.",
  "Membros da equipa": "Team members",
  "Modelos rápidos": "Quick templates",
  "Nenhum campo corresponde à pesquisa.": "No fields match your search.",
  "No Google Maps, escolhe Partilhar e copia a ligação.": "In Google Maps, choose Share and copy the link.",
  "Notas do pagamento": "Payment notes",
  "Notificação de reembolso": "Refund notification",
  "Notificações de pagamento interrompidas": "Payment notifications interrupted",
  "Não foi possível atualizar o estado neste momento. Vamos tentar novamente automaticamente.": "The status could not be updated right now. We will try again automatically.",
  "Não foi possível cancelar a edição deste campo.": "Could not cancel editing this field.",
  "Não foi possível cancelar a edição deste elemento.": "Could not cancel editing this element.",
  "Não foi possível criar o administrador. Confirme os dados introduzidos.": "Could not create the administrator. Check the information entered.",
  "Não foi possível enviar a imagem para o backend. Tenta novamente.": "Could not send the image to the backend. Please try again.",
  "Não foi possível enviar o pedido de reembolso.": "Could not send the refund request.",
  "Não foi possível exportar o ficheiro CSV.": "Could not export the CSV file.",
  "Não foi possível ordenar: o campo não tem identificador válido.": "Could not reorder: the field does not have a valid identifier.",
  "Não foi possível remover: o campo não tem identificador válido.": "Could not remove the field: it does not have a valid identifier.",
  "Não foi possível restaurar o campo.": "Could not restore the field.",
  "O backend criou o formulário, mas não devolveu o identificador.": "The backend created the form but did not return its identifier.",
  "O campo não tem identificador válido.": "The field does not have a valid identifier.",
  "A plataforma Formulários elimina configuração desnecessária para que se concentre no conteúdo e nos seus clientes.": "Forms removes unnecessary configuration so you can focus on content and your customers.",
  "O pagamento ainda não foi confirmado. Verifique o pedido na aplicação MB WAY.": "The payment has not yet been confirmed. Check the request in the MB WAY app.",
  "O pedido será enviado de forma segura para a Eupago e ficará registado como nota pendente. O estado do pagamento original não será alterado.": "The request will be sent securely to Eupago and recorded as a pending note. The original payment status will not be changed.",
  "O seu acesso à plataforma Formulários está pronto. Já pode iniciar sessão com o email e a palavra-passe que acabou de definir.": "Your Forms access is ready. You can now sign in with the email and password you just set.",
  "O seu formulário foi processado com sucesso. Abaixo pode ver os seus detalhes de pagamento:": "Your form was processed successfully. You can see your payment details below:",
  "O seu pagamento foi processado com sucesso!": "Your payment was processed successfully!",
  "O seu próximo formulário pode estar online hoje.": "Your next form can be online today.",
  "O subtítulo deve explicar o contexto ou o próximo passo.": "The subtitle should explain the context or the next step.",
  "O subtítulo deve explicar o que o utilizador deve fazer.": "The subtitle should explain what the user needs to do.",
  "Obrigatório. Deve explicar claramente que dado estás a pedir.": "Required. Clearly explain what information you are requesting.",
  "Obrigatório. Mantém o título curto e claro.": "Required. Keep the title short and clear.",
  "Ocorreu um erro enquanto tentamos fazer reset da sua palavra-passe": "An error occurred while trying to reset your password",
  "Opcional. Ajuda o utilizador a perceber o que deve fazer nesta secção.": "Optional. Helps the user understand what to do in this section.",
  "Opcional. Ajuda o utilizador com um exemplo de preenchimento.": "Optional. Helps the user with an example of how to fill it in.",
  "Opcional. Serve para orientar o utilizador antes dos próximos campos.": "Optional. Guides the user before the next fields.",
  "Opções avançadas: mapa incorporado por coordenadas": "Advanced options: map embedded using coordinates",
  "Organizado por secções para não obrigares o utilizador a procurar opções num formulário gigante.": "Organized into sections so the user does not have to search through a huge form.",
  "Os campos assinalados com * são obrigatórios.": "Fields marked with * are required.",
  "Os últimos formulários adicionados à plataforma.": "The latest forms added to the platform.",
  "ou clica para escolher um ficheiro JPG, PNG, BMP ou WEBP.": "or click to choose a JPG, PNG, BMP or WEBP file.",
  "Pagamento confirmado!": "Payment confirmed!",
  "Pagamento e estrutura": "Payment and structure",
  "pagamentos digitais": "digital payments",
  "Pagamentos integrados": "Integrated payments",
  "para publicar": "to publish",
  "Passwords não coincidem": "Passwords do not match",
  "Pausar": "Pause",
  "Pedido de reembolso pendente": "Refund request pending",
  "Pedimos desculpa, mas não encontramos a página que procura": "Sorry, we could not find the page you are looking for",
  "Pontuação por estrelas": "Star rating",
  "Por configurar": "Not configured",
  "Por segurança, o Client Secret guardado nunca é apresentado. Introduza um novo valor sempre que precisar de atualizar as credenciais.": "For security reasons, the saved Client Secret is never displayed. Enter a new value whenever you need to update the credentials.",
  "Preencha os dados abaixo e reveja o seu pedido antes de continuar.": "Fill in the details below and review your request before continuing.",
  "Problemas que precisam de atenção": "Issues that need attention",
  "Pré-visualização em computador": "Desktop preview",
  "Regras de preenchimento": "Input rules",
  "Repetir nova palavra-passe": "Repeat new password",
  "Requisitos para avançar": "Requirements to continue",
  "Reset da palavra-passe": "Password reset",
  "Respostas hoje": "Replies today",
  "Respostas organizadas": "Organized replies",
  "resultado": "result",
  "resultados": "results",
  "retirar o acesso de": "remove access from",
  "Se ativo, o utilizador será obrigado a escolher uma das opções fornecidas.": "When enabled, the user will be required to choose one of the provided options.",
  "Se marcado, o utilizador será obrigado a escolher uma das opções.": "When selected, the user will be required to choose one of the options.",
  "Seguro por natureza": "Secure by design",
  "Seleciona uma data no calendário.": "Select a date on the calendar.",
  "Selecione o método que pretende utilizar.": "Select the method you want to use.",
  "Sem pagamento definido": "No payment method configured",
  "será removido. Podes desfazer a ação logo a seguir.": "will be removed. You can undo the action immediately afterwards.",
  "Simples por fora. Poderoso por dentro.": "Simple on the outside. Powerful on the inside.",
  "Sincroniza a chave criptográfica para manter os estados dos pagamentos atualizados.": "Synchronize the cryptographic key to keep payment statuses up to date.",
  "Sobre este formulário": "About this form",
  "Tamanho da pré-visualização": "Preview size",
  "Tem campos adicionados": "Fields added",
  "Texto de uma nova opção que será adicionada à lista de escolha.": "Text for a new option that will be added to the selection list.",
  "Texto visível acima da caixa de seleção.": "Text displayed above the selection box.",
  "Texto visível acima do campo de valor no formulário.": "Text displayed above the value field on the form.",
  "Três passos entre a ideia e a primeira resposta.": "Three steps from the idea to the first reply.",
  "Uma experiência simples e segura para gerir inscrições, pedidos e pagamentos com a confiança Eupago.": "A simple and secure experience for managing registrations, requests and payments with Eupago's reliability.",
  "Uma notificação de pagamento não pôde ser validada. A chave criptográfica pode ter sido alterada na Eupago. Sincroniza novamente com a informação do canal para atualizar a chave neste formulário.": "A payment notification could not be validated. The cryptographic key may have changed at Eupago. Synchronize again with the channel information to update the key for this form.",
  "Usa este bloco para criar uma introdução, separador ou cabeçalho dentro do formulário.": "Use this block to create an introduction, divider or heading within the form.",
  "Usa imagem leve para não atrasar o carregamento.": "Use a lightweight image to avoid slowing down loading.",
  "Usa títulos curtos e objetivos.": "Use short, clear titles.",
  "Usa títulos curtos, diretos e orientados à ação.": "Use short, direct, action-oriented titles.",
  "Usa uma imagem simples, leve e legível. Ideal para logótipo, banner ou identificação visual do evento.": "Use a simple, lightweight and readable image. Ideal for a logo, banner or visual event identification.",
  "Usa uma legenda curta, como “Nome”, “Email” ou “Telefone”.": "Use a short label, such as “Name”, “Email” or “Phone”.",
  "Utilize pelo menos 8 caracteres, incluindo uma letra maiúscula e um número.": "Use at least 8 characters, including one uppercase letter and one number.",
  "Vais apagar o formulário": "You are about to delete the form",
  "Valor sugerido (€)": "Suggested amount (€)",
  "Voltar à Página Inicial": "Back to Home Page",
  "© Eupago - Instituição de Pagamento -": "© Eupago - Payment Institution -",
  "Última sincronização:": "Last synchronization:",
  "Disponíveis ao público": "Available to the public",
  "Indisponíveis ao público": "Unavailable to the public",
  "Pausados ou expirados": "Paused or expired",
  "URL copiado": "URL copied",
  "ID copiado": "ID copied",
  "A atualizar...": "Updating...",
  "Da ideia ao formulário publicado, sem complicações.": "From idea to published form, without complications.",
  "Consulte formulários, altere responsáveis e acompanhe as contas da plataforma num só lugar.": "View forms, change owners and monitor platform accounts in one place.",
  "Se ativo, este campo deve obrigatoriamente ser selecionado pelo utilizador.": "When enabled, this field must be selected by the user.",
  "Se ativo, este campo deve obrigatoriamente ser preenchido pelo utilizador.": "When enabled, this field must be completed by the user.",
  "← Voltar ao editor": "← Back to editor",
  "Disponível até": "Available until",
  "Criado em": "Created on",
});

Object.assign(exactES, {
  "(Sugestão:": "(Sugerencia:",
  "+ Produto / bilhete com preço": "+ Producto / entrada con precio",
  "- Eupago - Instituição de Pagamento": "- Eupago - Institución de Pago",
  ". Ele será marcado como apagado e deixará de aparecer nesta lista.": ". Se marcará como eliminado y dejará de aparecer en esta lista.",
  ". O código do seu registo é o seguinte:": ". El código de su registro es:",
  "A carregar credenciais...": "Cargando credenciales...",
  "A chave criptográfica pode ter sido alterada na Eupago. Sincroniza este formulário para voltar a receber estados de pagamento.": "La clave criptográfica puede haber cambiado en Eupago. Sincroniza este formulario para volver a recibir los estados de pago.",
  "A criar modelo. Aguarda um instante...": "Creando plantilla. Espera un momento...",
  "A imagem é opcional. Quando estiver tudo pronto, finaliza e regressa à lista de formulários.": "La imagen es opcional. Cuando todo esté listo, finaliza y vuelve a la lista de formularios.",
  "A infraestrutura Eupago protege os dados e os pagamentos.": "La infraestructura de Eupago protege los datos y los pagos.",
  "Abre cada resposta para consultar os campos preenchidos e os itens correspondentes.": "Abre cada respuesta para consultar los campos completados y los elementos correspondientes.",
  "adiciona um campo, usa o lápis para o configurar e confirma o estado à direita antes de avançar. Todas as ações são guardadas automaticamente.": "añade un campo, usa el lápiz para configurarlo y confirma el estado a la derecha antes de continuar. Todas las acciones se guardan automáticamente.",
  "Adicione um elemento para prosseguir.": "Añade un elemento para continuar.",
  "Ainda não existem formulários.": "Todavía no hay formularios.",
  "Ainda não tens campos de preço para aplicar stock por tipo.": "Todavía no tienes campos de precio para aplicar stock por tipo.",
  "Ainda não tens campos de preço para limitar por tipo.": "Todavía no tienes campos de precio para limitar por tipo.",
  "Após ver a necessidade real dos clientes Eupago de criarem formulários para os seus eventos onde pudessem incorporar métodos de pagamento. Surgiu a ideia de criar um sistema simples e eficaz que pudesse incorporar tudo isto num só local e daí nasceu a plataforma Formulários.": "Tras comprobar la necesidad real de los clientes de Eupago de crear formularios para sus eventos con métodos de pago integrados, surgió la idea de crear un sistema sencillo y eficaz que reuniera todo en un solo lugar. Así nació Formularios.",
  "Arrasta para ordenar. Usa o lápis para editar cada campo.": "Arrastra para ordenar. Usa el lápiz para editar cada campo.",
  "Arrasta uma imagem para aqui": "Arrastra una imagen aquí",
  "Arraste uma imagem para aqui": "Arrastra una imagen aquí",
  "As respostas aparecem aqui depois de um cliente concluir o formulário público.": "Las respuestas aparecen aquí después de que un cliente complete el formulario público.",
  "Atalhos rápidos": "Accesos rápidos",
  "Ativa esta opção quando a resposta for necessária para concluir o formulário.": "Activa esta opción cuando la respuesta sea necesaria para completar el formulario.",
  "Ativar": "Activar",
  "Ativar conta?": "¿Activar cuenta?",
  "Campo de texto curto": "Campo de texto corto",
  "Campo duplicado e guardado.": "Campo duplicado y guardado.",
  "Campo removido. Usa “Desfazer” se foi por engano.": "Campo eliminado. Usa «Deshacer» si fue por error.",
  "Campo restaurado com sucesso.": "Campo restaurado correctamente.",
  "Campo sem identificador": "Campo sin identificador",
  "Campos preenchidos": "Campos completados",
  "Cancelar seleção": "Cancelar selección",
  "Chave de produção": "Clave de producción",
  "Clica para adicionar ao formulário": "Haz clic para añadir al formulario",
  "Coloque uma componente do tipo Campo de Preço ou Doação, antes de finalizar.": "Añade un campo de Precio o Donación antes de finalizar.",
  "Com a plataforma Formulários consiga criar os seus formulários de forma simples e rápida integrando diretamente com os seus métodos de pagamentos na Eupago": "Con Formularios puede crear sus formularios de forma rápida y sencilla, integrándolos directamente con sus métodos de pago de Eupago.",
  "Comece a criar formulários": "Empieza a crear formularios",
  "Começa por um modelo ou adiciona campos manualmente. O utilizador vê a pré-visualização ao centro.": "Empieza con una plantilla o añade campos manualmente. El usuario ve la vista previa en el centro.",
  "Começar vazio": "Empezar vacío",
  "Conceda este perfil apenas a pessoas autorizadas a gerir toda a plataforma.": "Concede este perfil solo a personas autorizadas para gestionar toda la plataforma.",
  "Configure o conteúdo e confirme o resultado na pré-visualização.": "Configura el contenido y comprueba el resultado en la vista previa.",
  "Confirmamos que recebemos os dados que inseriu referente à sua compra no": "Confirmamos que hemos recibido los datos que introdujo relativos a su compra en",
  "Consulte os dados da sua conta, mantenha o acesso protegido e gira as credenciais da API Eupago.": "Consulta los datos de tu cuenta, mantén el acceso protegido y gestiona las credenciales de la API de Eupago.",
  "Continuar para o login": "Continuar al inicio de sesión",
  "Controla disponibilidade total ou por produto/preço.": "Controla la disponibilidad total o por producto/precio.",
  "Controla se o campo é obrigatório e que tipo de dado pode ser introduzido.": "Controla si el campo es obligatorio y qué tipo de dato se puede introducir.",
  "Copiar dados de pagamento": "Copiar datos de pago",
  "Copiar ID": "Copiar ID",
  "Copiar identificador": "Copiar identificador",
  "Copiar Identificador": "Copiar identificador",
  "Copiar URL": "Copiar URL",
  "Credenciais da API Eupago": "Credenciales de la API de Eupago",
  "Cria o primeiro formulário e começa com um modelo simples para o utilizador não ficar perdido no editor.": "Crea tu primer formulario y empieza con una plantilla sencilla para que el usuario pueda orientarse fácilmente en el editor.",
  "Criador de formulários": "Creador de formularios",
  "Criar conta gratuita": "Crear cuenta gratuita",
  "Crie acessos USER para os colaboradores e remova os que já não precisam de entrar.": "Crea accesos USER para los colaboradores y elimina los de quienes ya no necesiten entrar.",
  "Crie experiências profissionais, recolha respostas e receba pagamentos através de uma plataforma simples, integrada diretamente com a Eupago.": "Crea experiencias profesionales, recopila respuestas y recibe pagos mediante una plataforma sencilla integrada directamente con Eupago.",
  "Crie, publique e acompanhe respostas sem processos complicados.": "Crea, publica y sigue las respuestas sin procesos complicados.",
  "Crie, publique e receba pagamentos num só lugar.": "Crea, publica y recibe pagos en un solo lugar.",
  "Data inicial": "Fecha inicial",
  "Define a legenda, o texto de ajuda, a obrigatoriedade e a validação deste campo.": "Define la etiqueta, el texto de ayuda, si es obligatorio y la validación de este campo.",
  "Define o idioma da experiência pública sem alterar o idioma do backoffice.": "Define el idioma de la experiencia pública sin cambiar el idioma del backoffice.",
  "devolver o acesso a": "devolver el acceso a",
  "Disponível para reembolso": "Disponible para reembolso",
  "Enviado email com o link de recuperar palavra-passe": "Se ha enviado un email con el enlace para recuperar la contraseña",
  "Escolha o que pretende fazer com “": "Elige qué quieres hacer con «",
  "Escolha os artigos e as quantidades.": "Elige los artículos y las cantidades.",
  "Escolha uma palavra-passe forte e diferente das que utilizou anteriormente.": "Elige una contraseña segura y diferente de las que hayas utilizado anteriormente.",
  "Escolhe como o campo deve validar os dados introduzidos, por exemplo email, número ou NIF.": "Elige cómo debe validar el campo los datos introducidos, por ejemplo email, número o NIF.",
  "Escolhe um modelo ou preenche só o essencial. Depois editas os campos no construtor visual.": "Elige una plantilla o completa solo lo esencial. Después puedes editar los campos en el constructor visual.",
  "Escolhe validação quando queres evitar respostas inválidas.": "Elige una validación cuando quieras evitar respuestas no válidas.",
  "Escreve o valor desejado e clica no ícone": "Escribe el valor deseado y haz clic en el icono",
  "Esqueceu-se da palavra-passe?": "¿Has olvidado la contraseña?",
  "Esta ação remove o formulário e deixa de o disponibilizar aos clientes.": "Esta acción elimina el formulario y deja de ponerlo a disposición de los clientes.",
  "Estas credenciais serão utilizadas para gerir as integrações de todos os seus formulários.": "Estas credenciales se utilizarán para gestionar las integraciones de todos tus formularios.",
  "Este bloco serve para criar separadores, introduções ou cabeçalhos dentro do formulário.": "Este bloque sirve para crear separadores, introducciones o encabezados dentro del formulario.",
  "Este campo não tem identificador válido.": "Este campo no tiene un identificador válido.",
  "Este formulário não está disponível de momento. Por favor, tente novamente mais tarde.": "Este formulario no está disponible en este momento. Inténtalo de nuevo más tarde.",
  "Estes textos aparecem no formulário público e ajudam o utilizador a preencher corretamente.": "Estos textos aparecen en el formulario público y ayudan al usuario a completarlo correctamente.",
  "está a solicitar um pagamento através da Instituição de Pagamento Eupago Lda.": "está solicitando un pago a través de Eupago Lda., Institución de Pago.",
  "Está pronto para configurares pagamentos, stock e publicação.": "Está listo para configurar pagos, stock y publicación.",
  "Eupago. Todos os direitos reservados.": "Eupago. Todos los derechos reservados.",
  "Evita duplicar texto que já aparece noutros campos.": "Evita duplicar texto que ya aparece en otros campos.",
  "Evita o ecrã vazio: escolhe um ponto de partida e depois ajusta os campos ao teu caso.": "Evita una pantalla vacía: elige un punto de partida y después adapta los campos a tu caso.",
  "Evita repetir texto que já aparece noutros campos.": "Evita repetir texto que ya aparece en otros campos.",
  "Evita texto pequeno dentro da imagem.": "Evita texto pequeño dentro de la imagen.",
  "Ex.: Escreve aqui o teu nome": "Ej.: Escribe aquí tu nombre",
  "Ex.: Nome completo": "Ej.: Nombre completo",
  "Exemplo: Por motivos de segurança, o seu IP será guardado.": "Ejemplo: Por motivos de seguridad, se guardará tu dirección IP.",
  "Existem alterações por guardar.": "Hay cambios sin guardar.",
  "Experimente alterar os termos da pesquisa.": "Prueba a cambiar los términos de búsqueda.",
  "Ferramentas práticas, segurança Eupago e uma experiência pensada para equipas de qualquer dimensão.": "Herramientas prácticas, seguridad Eupago y una experiencia diseñada para equipos de cualquier tamaño.",
  "Ficheiro escolhido": "Archivo seleccionado",
  "Formulário apagado.": "Formulario eliminado.",
  "Formulários e pagamentos com tecnologia Eupago.": "Formularios y pagos con tecnología Eupago.",
  "Formulários existentes na plataforma": "Formularios existentes en la plataforma",
  "Formulários geridos": "Formularios gestionados",
  "Formulários inteligentes.": "Formularios inteligentes.",
  "Formulários que trabalham por si": "Formularios que trabajan por ti",
  "Formulários recentes": "Formularios recientes",
  "Gerir, editar e publicar formulários": "Gestionar, editar y publicar formularios",
  "Guarda primeiro a nova Chave API antes de sincronizar.": "Guarda primero la nueva clave API antes de sincronizar.",
  "Idioma do backoffice": "Idioma del backoffice",
  "Imagem pronta para envio.": "Imagen lista para enviar.",
  "Impede o envio sem resposta.": "Impide el envío sin respuesta.",
  "Inativar conta?": "¿Desactivar cuenta?",
  "Indique o email associado à sua conta. Enviaremos um link seguro válido durante 15 minutos.": "Indica el email asociado a tu cuenta. Te enviaremos un enlace seguro válido durante 15 minutos.",
  "Introduz um valor de reembolso válido.": "Introduce un importe de reembolso válido.",
  "Já tenho conta": "Ya tengo una cuenta",
  "Larga a imagem aqui": "Suelta la imagen aquí",
  "Largue aqui a sua imagem": "Suelta aquí tu imagen",
  "Limite de Referências Pagas?": "¿Límite de referencias pagadas?",
  "Marca como obrigatório apenas o que for mesmo necessário.": "Marca como obligatorio solo lo que sea realmente necesario.",
  "MB WAY, Multibanco e cartão diretamente nos seus formulários.": "MB WAY, Multibanco y tarjeta directamente en tus formularios.",
  "Membros da equipa": "Miembros del equipo",
  "Modelos rápidos": "Plantillas rápidas",
  "Nenhum campo corresponde à pesquisa.": "Ningún campo coincide con la búsqueda.",
  "No Google Maps, escolhe Partilhar e copia a ligação.": "En Google Maps, elige Compartir y copia el enlace.",
  "Notas do pagamento": "Notas del pago",
  "Notificação de reembolso": "Notificación de reembolso",
  "Notificações de pagamento interrompidas": "Notificaciones de pago interrumpidas",
  "Não foi possível atualizar o estado neste momento. Vamos tentar novamente automaticamente.": "No se pudo actualizar el estado en este momento. Lo intentaremos de nuevo automáticamente.",
  "Não foi possível cancelar a edição deste campo.": "No se pudo cancelar la edición de este campo.",
  "Não foi possível cancelar a edição deste elemento.": "No se pudo cancelar la edición de este elemento.",
  "Não foi possível criar o administrador. Confirme os dados introduzidos.": "No se pudo crear el administrador. Comprueba los datos introducidos.",
  "Não foi possível enviar a imagem para o backend. Tenta novamente.": "No se pudo enviar la imagen al backend. Inténtalo de nuevo.",
  "Não foi possível enviar o pedido de reembolso.": "No se pudo enviar la solicitud de reembolso.",
  "Não foi possível exportar o ficheiro CSV.": "No se pudo exportar el archivo CSV.",
  "Não foi possível ordenar: o campo não tem identificador válido.": "No se pudo ordenar: el campo no tiene un identificador válido.",
  "Não foi possível remover: o campo não tem identificador válido.": "No se pudo eliminar: el campo no tiene un identificador válido.",
  "Não foi possível restaurar o campo.": "No se pudo restaurar el campo.",
  "O backend criou o formulário, mas não devolveu o identificador.": "El backend creó el formulario, pero no devolvió el identificador.",
  "O campo não tem identificador válido.": "El campo no tiene un identificador válido.",
  "A plataforma Formulários elimina configuração desnecessária para que se concentre no conteúdo e nos seus clientes.": "Formularios elimina la configuración innecesaria para que puedas centrarte en el contenido y en tus clientes.",
  "O pagamento ainda não foi confirmado. Verifique o pedido na aplicação MB WAY.": "El pago todavía no se ha confirmado. Comprueba la solicitud en la aplicación MB WAY.",
  "O pedido será enviado de forma segura para a Eupago e ficará registado como nota pendente. O estado do pagamento original não será alterado.": "La solicitud se enviará de forma segura a Eupago y quedará registrada como nota pendiente. El estado del pago original no se modificará.",
  "O seu acesso à plataforma Formulários está pronto. Já pode iniciar sessão com o email e a palavra-passe que acabou de definir.": "Tu acceso a Formularios está listo. Ya puedes iniciar sesión con el email y la contraseña que acabas de definir.",
  "O seu formulário foi processado com sucesso. Abaixo pode ver os seus detalhes de pagamento:": "Tu formulario se ha procesado correctamente. A continuación puedes ver los datos del pago:",
  "O seu pagamento foi processado com sucesso!": "¡Tu pago se ha procesado correctamente!",
  "O seu próximo formulário pode estar online hoje.": "Tu próximo formulario puede estar online hoy.",
  "O subtítulo deve explicar o contexto ou o próximo passo.": "El subtítulo debe explicar el contexto o el siguiente paso.",
  "O subtítulo deve explicar o que o utilizador deve fazer.": "El subtítulo debe explicar lo que debe hacer el usuario.",
  "Obrigatório. Deve explicar claramente que dado estás a pedir.": "Obligatorio. Explica claramente qué dato estás solicitando.",
  "Obrigatório. Mantém o título curto e claro.": "Obligatorio. Mantén el título corto y claro.",
  "Ocorreu um erro enquanto tentamos fazer reset da sua palavra-passe": "Se produjo un error al intentar restablecer tu contraseña",
  "Opcional. Ajuda o utilizador a perceber o que deve fazer nesta secção.": "Opcional. Ayuda al usuario a entender qué debe hacer en esta sección.",
  "Opcional. Ajuda o utilizador com um exemplo de preenchimento.": "Opcional. Ayuda al usuario con un ejemplo de cómo completarlo.",
  "Opcional. Serve para orientar o utilizador antes dos próximos campos.": "Opcional. Sirve para orientar al usuario antes de los siguientes campos.",
  "Opções avançadas: mapa incorporado por coordenadas": "Opciones avanzadas: mapa integrado mediante coordenadas",
  "Organizado por secções para não obrigares o utilizador a procurar opções num formulário gigante.": "Organizado por secciones para que el usuario no tenga que buscar opciones en un formulario enorme.",
  "Os campos assinalados com * são obrigatórios.": "Los campos marcados con * son obligatorios.",
  "Os últimos formulários adicionados à plataforma.": "Los últimos formularios añadidos a la plataforma.",
  "ou clica para escolher um ficheiro JPG, PNG, BMP ou WEBP.": "o haz clic para elegir un archivo JPG, PNG, BMP o WEBP.",
  "Pagamento confirmado!": "¡Pago confirmado!",
  "Pagamento e estrutura": "Pago y estructura",
  "pagamentos digitais": "pagos digitales",
  "Pagamentos integrados": "Pagos integrados",
  "para publicar": "para publicar",
  "Passwords não coincidem": "Las contraseñas no coinciden",
  "Pausar": "Pausar",
  "Pedido de reembolso pendente": "Solicitud de reembolso pendiente",
  "Pedimos desculpa, mas não encontramos a página que procura": "Lo sentimos, no hemos encontrado la página que buscas",
  "Pontuação por estrelas": "Puntuación por estrellas",
  "Por configurar": "Sin configurar",
  "Por segurança, o Client Secret guardado nunca é apresentado. Introduza um novo valor sempre que precisar de atualizar as credenciais.": "Por seguridad, el Client Secret guardado nunca se muestra. Introduce un nuevo valor siempre que necesites actualizar las credenciales.",
  "Preencha os dados abaixo e reveja o seu pedido antes de continuar.": "Completa los datos siguientes y revisa tu solicitud antes de continuar.",
  "Problemas que precisam de atenção": "Problemas que requieren atención",
  "Pré-visualização em computador": "Vista previa en ordenador",
  "Regras de preenchimento": "Reglas de cumplimentación",
  "Repetir nova palavra-passe": "Repetir nueva contraseña",
  "Requisitos para avançar": "Requisitos para continuar",
  "Reset da palavra-passe": "Restablecimiento de contraseña",
  "Respostas hoje": "Respuestas hoy",
  "Respostas organizadas": "Respuestas organizadas",
  "resultado": "resultado",
  "resultados": "resultados",
  "retirar o acesso de": "retirar el acceso de",
  "Se ativo, o utilizador será obrigado a escolher uma das opções fornecidas.": "Si está activo, el usuario deberá elegir una de las opciones proporcionadas.",
  "Se marcado, o utilizador será obrigado a escolher uma das opções.": "Si está marcado, el usuario deberá elegir una de las opciones.",
  "Seguro por natureza": "Seguro por diseño",
  "Seleciona uma data no calendário.": "Selecciona una fecha en el calendario.",
  "Selecione o método que pretende utilizar.": "Selecciona el método que quieres utilizar.",
  "Sem pagamento definido": "Sin método de pago configurado",
  "será removido. Podes desfazer a ação logo a seguir.": "se eliminará. Puedes deshacer la acción justo después.",
  "Simples por fora. Poderoso por dentro.": "Simple por fuera. Potente por dentro.",
  "Sincroniza a chave criptográfica para manter os estados dos pagamentos atualizados.": "Sincroniza la clave criptográfica para mantener actualizados los estados de los pagos.",
  "Sobre este formulário": "Sobre este formulario",
  "Tamanho da pré-visualização": "Tamaño de la vista previa",
  "Tem campos adicionados": "Tiene campos añadidos",
  "Texto de uma nova opção que será adicionada à lista de escolha.": "Texto de una nueva opción que se añadirá a la lista de selección.",
  "Texto visível acima da caixa de seleção.": "Texto visible encima del cuadro de selección.",
  "Texto visível acima do campo de valor no formulário.": "Texto visible encima del campo de valor del formulario.",
  "Três passos entre a ideia e a primeira resposta.": "Tres pasos entre la idea y la primera respuesta.",
  "Uma experiência simples e segura para gerir inscrições, pedidos e pagamentos com a confiança Eupago.": "Una experiencia sencilla y segura para gestionar inscripciones, solicitudes y pagos con la confianza de Eupago.",
  "Uma notificação de pagamento não pôde ser validada. A chave criptográfica pode ter sido alterada na Eupago. Sincroniza novamente com a informação do canal para atualizar a chave neste formulário.": "No se pudo validar una notificación de pago. La clave criptográfica puede haber cambiado en Eupago. Vuelve a sincronizar con la información del canal para actualizar la clave de este formulario.",
  "Usa este bloco para criar uma introdução, separador ou cabeçalho dentro do formulário.": "Usa este bloque para crear una introducción, separador o encabezado dentro del formulario.",
  "Usa imagem leve para não atrasar o carregamento.": "Usa una imagen ligera para no retrasar la carga.",
  "Usa títulos curtos e objetivos.": "Usa títulos cortos y claros.",
  "Usa títulos curtos, diretos e orientados à ação.": "Usa títulos cortos, directos y orientados a la acción.",
  "Usa uma imagem simples, leve e legível. Ideal para logótipo, banner ou identificação visual do evento.": "Usa una imagen sencilla, ligera y legible. Ideal para un logotipo, banner o identificación visual del evento.",
  "Usa uma legenda curta, como “Nome”, “Email” ou “Telefone”.": "Usa una etiqueta corta, como «Nombre», «Email» o «Teléfono».",
  "Utilize pelo menos 8 caracteres, incluindo uma letra maiúscula e um número.": "Utiliza al menos 8 caracteres, incluida una letra mayúscula y un número.",
  "Vais apagar o formulário": "Vas a eliminar el formulario",
  "Valor sugerido (€)": "Importe sugerido (€)",
  "Voltar à Página Inicial": "Volver a la página de inicio",
  "© Eupago - Instituição de Pagamento -": "© Eupago - Institución de Pago -",
  "Última sincronização:": "Última sincronización:",
  "Disponíveis ao público": "Disponibles para el público",
  "Indisponíveis ao público": "No disponibles para el público",
  "Pausados ou expirados": "Pausados o caducados",
  "URL copiado": "URL copiada",
  "ID copiado": "ID copiado",
  "A atualizar...": "Actualizando...",
  "Da ideia ao formulário publicado, sem complicações.": "De la idea al formulario publicado, sin complicaciones.",
  "Consulte formulários, altere responsáveis e acompanhe as contas da plataforma num só lugar.": "Consulta formularios, cambia responsables y supervisa las cuentas de la plataforma en un solo lugar.",
  "Se ativo, este campo deve obrigatoriamente ser selecionado pelo utilizador.": "Si está activo, el usuario debe seleccionar este campo obligatoriamente.",
  "Se ativo, este campo deve obrigatoriamente ser preenchido pelo utilizador.": "Si está activo, el usuario debe completar este campo obligatoriamente.",
  "← Voltar ao editor": "← Volver al editor",
  "Disponível até": "Disponible hasta",
  "Criado em": "Creado el",
});

// Final audit pass: natural translations for phrases that previously fell through to word-by-word fallback.
Object.assign(exactEN, {
  "Acompanhe a atividade da plataforma e aceda rapidamente às principais áreas de gestão.": "Monitor platform activity and quickly access the main management areas.",
  "Não foi possível alterar o responsável.": "Could not change the owner.",
  "Consulte todos os formulários, altere o responsável e aceda às ações de gestão.": "View all forms, change the owner and access management actions.",
  "Não foi possível carregar os formulários.": "Could not load the forms.",
  "Adicione as coordenadas do seu Evento para visualizar o mapa do local, mantenha os valores a 0 para não mostrar o mapa.": "Add your event coordinates to display the location map. Keep both values at 0 to hide the map.",
  "O seu formulário foi guardado com sucesso": "Your form was saved successfully",
  "A palavra-passe deve ter pelo menos 8 caracteres, uma letra maiúscula e um número.": "The password must contain at least 8 characters, one uppercase letter and one number.",
  "Preencha os dados do novo administrador.": "Enter the details for the new administrator.",
  "A nova palavra-passe deve ter pelo menos 8 caracteres.": "The new password must contain at least 8 characters.",
  "Não foi possível alterar a palavra-passe. Confirme a palavra-passe atual.": "Could not change the password. Check your current password.",
  "Consulte o seu perfil de administrador e mantenha o acesso protegido.": "View your administrator profile and keep your account secure.",
  "Utilize pelo menos 8 caracteres e evite reutilizar palavras-passe.": "Use at least 8 characters and avoid reusing passwords.",
  "Não foi possível alterar a função.": "Could not change the role.",
  "Não foi possível carregar os utilizadores.": "Could not load the users.",
  "Acompanhe os formulários da sua conta e faça a gestão da equipa.": "Track the forms in your account and manage your team.",
  "Formulários da empresa": "Company forms",
  "Crie, publique e acompanhe os formulários associados à sua conta.": "Create, publish and track the forms associated with your account.",
  "Não foi possível carregar a equipa.": "Could not load the team.",
  "Não foi possível criar o acesso.": "Could not create the user access.",
  "Não foi possível remover este acesso.": "Could not remove this user access.",
  "Faça a gestão dos utilizadores associados à sua empresa.": "Manage the users associated with your company.",
  "Crie o primeiro acesso para a sua equipa.": "Create the first user access for your team.",
  "Este acesso terá a função USER e ficará automaticamente associado à sua empresa.": "This user access will have the USER role and will automatically be associated with your company.",
  "Não foi possível enviar o formulário.": "Could not submit the form.",
  "Os seus dados": "Your details",
  "A enviar…": "Sending…",
  "Não foi possível alterar o estado do formulário.": "Could not change the form status.",
  "Constrói o conteúdo do formulário": "Build the form content",
  "Não foi possível criar a cópia.": "Could not create the copy.",
  "Não foi possível duplicar o campo.": "Could not duplicate the field.",
  "Não foi possível criar o campo.": "Could not create the field.",
  "Não foi possível criar o modelo. Tenta novamente.": "Could not create the template. Please try again.",
  "Não foi possível ordenar o campo.": "Could not reorder the field.",
  "Não foi possível remover o campo.": "Could not remove the field.",
  "O teu formulário": "Your form",
  "Define o idioma da experiência pública sem alterar o idioma do backoffice.": "Set the public form language without changing the backoffice language.",
  "A sincronizar…": "Synchronizing…",
  "Partilha facilmente a localização de um evento físico.": "Easily share the location of a physical event.",
  "Não foi possível remover a imagem.": "Could not remove the image.",
  "A enviar...": "Sending...",
  "Pessoas a criar um formulário": "People creating a form",
  "Uma área de trabalho clara para construir, gerir e acompanhar tudo o que importa.": "A clear workspace to build, manage and track everything that matters.",
  "Tudo o que precisa para criar melhores formulários.": "Everything you need to create better forms.",
  "Introduza a sua palavra-passe": "Enter your password",
  "Veja como obter o seu Client ID": "See how to get your Client ID",
  "Veja como obter o seu Client Secret": "See how to get your Client Secret",
  "A criar conta...": "Creating account...",
  "Não foi possível carregar as respostas.": "Could not load the replies.",
  "Voltar à página de login": "Back to the login page",
  "Não foi possível carregar a fotografia.": "Could not load the photo.",
  "Não foi possível enviar a fotografia.": "Could not upload the photo.",
  "Não foi possível alterar a palavra-passe.": "Could not change the password.",
  "Adicione pelo menos uma opção.": "Add at least one option.",
  "Crie os seus formulários sem complicações": "Create your forms without hassle",
  "O seu formulário foi preenchido com sucesso!": "Your form was submitted successfully!",
  "A legenda do campo é obrigatória.": "The field label is required.",
});

Object.assign(exactES, {
  "Acompanhe a atividade da plataforma e aceda rapidamente às principais áreas de gestão.": "Sigue la actividad de la plataforma y accede rápidamente a las principales áreas de gestión.",
  "Não foi possível alterar o responsável.": "No se pudo cambiar el responsable.",
  "Consulte todos os formulários, altere o responsável e aceda às ações de gestão.": "Consulta todos los formularios, cambia el responsable y accede a las acciones de gestión.",
  "Não foi possível carregar os formulários.": "No se pudieron cargar los formularios.",
  "Adicione as coordenadas do seu Evento para visualizar o mapa do local, mantenha os valores a 0 para não mostrar o mapa.": "Añade las coordenadas de tu evento para mostrar el mapa de la ubicación. Mantén ambos valores en 0 para ocultar el mapa.",
  "O seu formulário foi guardado com sucesso": "Tu formulario se ha guardado correctamente",
  "A palavra-passe deve ter pelo menos 8 caracteres, uma letra maiúscula e um número.": "La contraseña debe contener al menos 8 caracteres, una letra mayúscula y un número.",
  "Preencha os dados do novo administrador.": "Introduce los datos del nuevo administrador.",
  "A nova palavra-passe deve ter pelo menos 8 caracteres.": "La nueva contraseña debe contener al menos 8 caracteres.",
  "Não foi possível alterar a palavra-passe. Confirme a palavra-passe atual.": "No se pudo cambiar la contraseña. Comprueba tu contraseña actual.",
  "Consulte o seu perfil de administrador e mantenha o acesso protegido.": "Consulta tu perfil de administrador y mantén tu cuenta protegida.",
  "Utilize pelo menos 8 caracteres e evite reutilizar palavras-passe.": "Utiliza al menos 8 caracteres y evita reutilizar contraseñas.",
  "Não foi possível alterar a função.": "No se pudo cambiar la función.",
  "Não foi possível carregar os utilizadores.": "No se pudieron cargar los usuarios.",
  "Acompanhe os formulários da sua conta e faça a gestão da equipa.": "Sigue los formularios de tu cuenta y gestiona tu equipo.",
  "Formulários da empresa": "Formularios de la empresa",
  "Crie, publique e acompanhe os formulários associados à sua conta.": "Crea, publica y sigue los formularios asociados a tu cuenta.",
  "Não foi possível carregar a equipa.": "No se pudo cargar el equipo.",
  "Não foi possível criar o acesso.": "No se pudo crear el acceso de usuario.",
  "Não foi possível remover este acesso.": "No se pudo eliminar este acceso de usuario.",
  "Faça a gestão dos utilizadores associados à sua empresa.": "Gestiona los usuarios asociados a tu empresa.",
  "Crie o primeiro acesso para a sua equipa.": "Crea el primer acceso de usuario para tu equipo.",
  "Este acesso terá a função USER e ficará automaticamente associado à sua empresa.": "Este acceso tendrá la función USER y se asociará automáticamente a tu empresa.",
  "Não foi possível enviar o formulário.": "No se pudo enviar el formulario.",
  "Os seus dados": "Tus datos",
  "A enviar…": "Enviando…",
  "Não foi possível alterar o estado do formulário.": "No se pudo cambiar el estado del formulario.",
  "Constrói o conteúdo do formulário": "Construye el contenido del formulario",
  "Não foi possível criar a cópia.": "No se pudo crear la copia.",
  "Não foi possível duplicar o campo.": "No se pudo duplicar el campo.",
  "Não foi possível criar o campo.": "No se pudo crear el campo.",
  "Não foi possível criar o modelo. Tenta novamente.": "No se pudo crear la plantilla. Inténtalo de nuevo.",
  "Não foi possível ordenar o campo.": "No se pudo reordenar el campo.",
  "Não foi possível remover o campo.": "No se pudo eliminar el campo.",
  "O teu formulário": "Tu formulario",
  "Define o idioma da experiência pública sem alterar o idioma do backoffice.": "Define el idioma del formulario público sin cambiar el idioma del backoffice.",
  "A sincronizar…": "Sincronizando…",
  "Partilha facilmente a localização de um evento físico.": "Comparte fácilmente la ubicación de un evento físico.",
  "Não foi possível remover a imagem.": "No se pudo eliminar la imagen.",
  "A enviar...": "Enviando...",
  "Pessoas a criar um formulário": "Personas creando un formulario",
  "Uma área de trabalho clara para construir, gerir e acompanhar tudo o que importa.": "Un espacio de trabajo claro para crear, gestionar y seguir todo lo importante.",
  "Tudo o que precisa para criar melhores formulários.": "Todo lo que necesitas para crear mejores formularios.",
  "Introduza a sua palavra-passe": "Introduce tu contraseña",
  "Veja como obter o seu Client ID": "Consulta cómo obtener tu Client ID",
  "Veja como obter o seu Client Secret": "Consulta cómo obtener tu Client Secret",
  "A criar conta...": "Creando cuenta...",
  "Não foi possível carregar as respostas.": "No se pudieron cargar las respuestas.",
  "Voltar à página de login": "Volver a la página de inicio de sesión",
  "Não foi possível carregar a fotografia.": "No se pudo cargar la foto.",
  "Não foi possível enviar a fotografia.": "No se pudo subir la foto.",
  "Não foi possível alterar a palavra-passe.": "No se pudo cambiar la contraseña.",
  "Adicione pelo menos uma opção.": "Añade al menos una opción.",
  "Crie os seus formulários sem complicações": "Crea tus formularios sin complicaciones",
  "O seu formulário foi preenchido com sucesso!": "¡Tu formulario se ha enviado correctamente!",
  "A legenda do campo é obrigatória.": "La etiqueta del campo es obligatoria.",
});

// Natural wording pass for remaining UI labels found by the full scene/component audit.
Object.assign(exactEN, {
  "Submissões recebidas em todos os formulários": "Submissions received across all forms",
  "Formulário sem nome": "Unnamed form",
  "Sem utilizador associado": "No user assigned",
  "Em pausa": "Paused",
  "Editor Formulário": "Form editor",
  "Ações de gestão": "Management actions",
  "Dados da conta": "Account details",
  "Consulte contas, altere permissões e controle o acesso à plataforma.": "View accounts, change permissions and control access to the platform.",
  "A palavra-passe deve ter 8 caracteres, uma maiúscula e um número.": "The password must contain 8 characters, one uppercase letter and one number.",
  "Todos os Formulários": "All forms",
  "Título do Formulário:": "Form title:",
  "Informação do Formulário:": "Form information:",
  "Nome do formulário *": "Form name *",
  "Podes usar HTML simples, por exemplo <b>texto</b> ou <p>parágrafo</p>.": "You can use simple HTML, for example <b>text</b> or <p>paragraph</p>.",
  "Escolhe só os métodos necessários. A referência Multibanco pode ter ou não prazo.": "Choose only the payment methods you need. The Multibanco reference can have an optional deadline.",
  "Define se a referência tem prazo ou fica disponível sem prazo.": "Choose whether the reference has a payment deadline or remains available without one.",
  "Imagem atual do formulário": "Current form image",
  "Podes finalizar sem imagem se o formulário for simples.": "You can finish without an image if the form is simple.",
  "Pagamentos sem esforço.": "Effortless payments.",
  "Sem custos de utilização": "No usage fees",
  "Da ideia ao formulário publicado, sem complicações.": "From idea to published form, without hassle.",
  "Área de gestão de formulários": "Forms management area",
  "Email ou Password Inválido": "Invalid email or password",
  "Altera ou limpa a pesquisa.": "Change or clear the search.",
  "Sem alterações pendentes.": "No pending changes.",
  "Dados copiados": "Details copied",
  "Sem validação": "No validation",
  "Informação que identifica o formulário e aparece para o utilizador.": "Information that identifies the form and is displayed to the user.",
  "Usa uma imagem simples, leve e legível. Ideal para logótipo, banner ou identificação visual do evento.": "Use a simple, lightweight and readable image. Ideal for a logo, banner or event visual.",
  "Introduza o seu email": "Enter your email",
  "Respostas recebidas": "Replies received",
  "Estado não disponível": "Status unavailable",
  "Por configurar": "Not configured",
});

Object.assign(exactES, {
  "Submissões recebidas em todos os formulários": "Envíos recibidos en todos los formularios",
  "Formulário sem nome": "Formulario sin nombre",
  "Sem utilizador associado": "Sin usuario asignado",
  "Em pausa": "Pausado",
  "Editor Formulário": "Editor de formulario",
  "Ações de gestão": "Acciones de gestión",
  "Dados da conta": "Datos de la cuenta",
  "Consulte contas, altere permissões e controle o acesso à plataforma.": "Consulta las cuentas, cambia los permisos y controla el acceso a la plataforma.",
  "A palavra-passe deve ter 8 caracteres, uma maiúscula e um número.": "La contraseña debe contener 8 caracteres, una letra mayúscula y un número.",
  "Todos os Formulários": "Todos los formularios",
  "Título do Formulário:": "Título del formulario:",
  "Informação do Formulário:": "Información del formulario:",
  "Nome do formulário *": "Nombre del formulario *",
  "Podes usar HTML simples, por exemplo <b>texto</b> ou <p>parágrafo</p>.": "Puedes usar HTML sencillo, por ejemplo <b>texto</b> o <p>párrafo</p>.",
  "Escolhe só os métodos necessários. A referência Multibanco pode ter ou não prazo.": "Elige solo los métodos de pago necesarios. La referencia Multibanco puede tener un plazo opcional.",
  "Define se a referência tem prazo ou fica disponível sem prazo.": "Elige si la referencia tiene un plazo de pago o queda disponible sin él.",
  "Imagem atual do formulário": "Imagen actual del formulario",
  "Podes finalizar sem imagem se o formulário for simples.": "Puedes finalizar sin imagen si el formulario es sencillo.",
  "Pagamentos sem esforço.": "Pagos sin esfuerzo.",
  "Sem custos de utilização": "Sin costes de uso",
  "Da ideia ao formulário publicado, sem complicações.": "De la idea al formulario publicado, sin complicaciones.",
  "Área de gestão de formulários": "Área de gestión de Formularios",
  "Email ou Password Inválido": "Email o contraseña no válidos",
  "Altera ou limpa a pesquisa.": "Cambia o limpia la búsqueda.",
  "Sem alterações pendentes.": "Sin cambios pendientes.",
  "Dados copiados": "Datos copiados",
  "Sem validação": "Sin validación",
  "Informação que identifica o formulário e aparece para o utilizador.": "Información que identifica el formulario y se muestra al usuario.",
  "Usa uma imagem simples, leve e legível. Ideal para logótipo, banner ou identificação visual do evento.": "Usa una imagen sencilla, ligera y legible. Ideal para un logotipo, banner o imagen del evento.",
  "Introduza o seu email": "Introduce tu email",
  "Respostas recebidas": "Respuestas recibidas",
  "Estado não disponível": "Estado no disponible",
  "Por configurar": "Sin configurar",
});

Object.assign(exactEN, { "Imagem atual": "Current image" });
Object.assign(exactES, { "Imagem atual": "Imagen actual" });


// Complete static UI coverage for IT-1188. Keep this map exact: it prevents user/content strings
// and technical values from being altered by the generic translator.
Object.assign(exactEN, {
  "comentário": "comment",
  "validação": "validation",
  "seleção": "selection",
  "avaliação": "rating",
  "preço": "price",
  "elemento": "element",
  "Sugestão": "Suggestion",
  "A Chave API da Eupago é obrigatória para pagamentos online.": "The Eupago API key is required for online payments.",
  "Portugal": "Portugal",
  "Espanha": "Spain",
  "Itália": "Italy",
  "Tem a certeza que quer apagar este formulário?": "Are you sure you want to delete this form?",
  "Selecionar uma opção": "Select an option",
  "estrela": "star",
  "estrelas": "stars",
  "Campo Obrigatório:": "Required field:",
  "Sucesso:": "Success:",
  "Dados guardados com sucesso!": "Data saved successfully!",
  "Adicionar Opção": "Add option",
  "Editar Doação": "Edit donation",
  "caixa de texto": "text box",
  "escolha múltipla": "multiple choice",
  "data": "date",
  "informação": "information",
  "doação": "donation",
  "A legenda é obrigatória.": "The label is required.",
  "O preço mínimo por artigo é 0,05 €.": "The minimum price per item is €0.05.",
  "Introduza um valor válido.": "Enter a valid value.",
  "formulário": "form",
  "Elemento guardado com sucesso.": "Element saved successfully.",
  "Conteúdo": "Content",
  "Definições do campo": "Field settings",
  "Opcional, por exemplo ^[0-9]+$": "Optional, for example ^[0-9]+$",
  "Valor (€) *": "Value (€) *",
  "Adicionar": "Add",
  "Legenda do campo": "Field label",
  "Valor mínimo: 0,05 €.": "Minimum value: €0.05.",
  "Elemento atualizado com sucesso!": "Element updated successfully!",
  "Máximo de 2000 caracteres": "Maximum 2000 characters",
  "O título é obrigatório.": "The title is required.",
  "Editar título do formulário": "Edit form title",
  "Define o título principal e o subtítulo que aparecem no formulário público.": "Set the main title and subtitle shown on the public form.",
  "Texto do título": "Title text",
  "Ex.: Inscrição no workshop": "E.g.: Workshop registration",
  "Usa uma frase curta e clara. Este texto aparece em destaque.": "Use a short, clear sentence. This text is displayed prominently.",
  "Voltar": "Back",
  "Título da secção": "Section title",
  "Selecionar": "Select",
  "Data": "Date",
  "Ainda não é cliente Eupago?": "Not a Eupago customer yet?",
  "hover:text-green-claro": "hover:text-green-claro",
  "Crie os seus formulários sem a necessidade de qualquer conhecimento em programação": "Create your forms without any programming knowledge.",
  "Partilhe os seus formulários com os seus clientes de forma simples e rápida": "Share your forms with your customers quickly and easily.",
  "Com a plataforma Formulários consegui criar os meus formulários rapidamente e partilhar com todos os meus clientes que facilmente os preencheram e pagaram de forma segura": "With Forms I was able to create my forms quickly and share them with all my customers, who could easily complete them and pay securely.",
  "Ocorreu um erro; tente novamente com outro método de pagamento.": "An error occurred; please try another payment method.",
  "Ocorreu um erro. Por favor tente novamente.": "An error occurred. Please try again.",
  "Introduza os 9 algarismos do número português.": "Enter the 9 digits of the Portuguese number.",
  "Introduza os 9 algarismos do número espanhol.": "Enter the 9 digits of the Spanish number.",
  "Introduza entre 6 e 11 algarismos do número italiano.": "Enter between 6 and 11 digits of the Italian number.",
  "Formulário preenchido com sucesso!": "Form completed successfully!",
  "Donativos": "Donations",
  "no valor de": "for the amount of",
  "O pagamento foi concluído com sucesso.": "The payment was completed successfully.",
  "Pagamento Multibanco": "Multibanco payment",
  "Data limite": "Due date",
  "Texto que será exibido como título do campo no formulário.": "Text displayed as the field title on the form.",
  "para o adicionar à lista.": "to add it to the list.",
  "Email de informação de pagamento": "Payment information email",
  "NIF português": "Portuguese tax number",
  "Validação mais genérica.": "More generic validation.",
  "Contacto telefónico com indicativo": "Phone number with country code",
  "Editar campo de texto": "Edit text field",
  "Dados guardados com sucesso.": "Data stored successfully.",
  "Identificação do campo": "Field identification",
  "Tipo de validação": "Validation type",
  "Texto de exemplo dentro do campo": "Example text inside the field",
  "Se cancelares um campo recém-criado sem preencher nada, ele será removido automaticamente.": "If you cancel a newly created field without filling anything in, it will be removed automatically.",
  "Texto principal exibido como cabeçalho no formulário.": "Main text displayed as the form heading.",
  "Verde da marca e superfícies claras.": "Brand green with light surfaces.",
  "Claro": "Light",
  "Escuro": "Dark",
  "Fundo escuro com dourado intenso e texto claro.": "Dark background with strong gold accents and light text.",
  "Espaço, conteúdo e contornos discretos.": "Clean spacing, content and subtle borders.",
  "Escolhe o HEX dos botões e destaques.": "Choose the HEX colour for buttons and highlights.",
  "Gerir formulários": "Manage forms",
  "Contas com acesso à plataforma": "Accounts with access to the platform",
  "Gerir utilizadores": "Manage users",
  "Novo formulário": "New form",
  "Escolha Múltipla": "Multiple choice",
  "Linha de Divisão": "Divider",
  "Não foi possível criar o formulário.": "Could not create the form.",
  "Criar formulário": "Create form",
  "formulários": "forms",
  "Editar campos": "Edit fields",
  "Ver respostas": "View replies",
  "Apagar formulário": "Delete form",
  "Nenhum formulário encontrado": "No forms found",
  "Altere a pesquisa ou crie um novo formulário.": "Change the search or create a new form.",
  "de": "of",
  "Apagar formulário?": "Delete form?",
  "Apagar": "Delete",
  "O formulário só será guardado depois de indicar um nome.": "The form will only be saved after you enter a name.",
  "Ex.: Inscrição no evento": "E.g.: Event registration",
  "Criar e continuar": "Create and continue",
  "para negrito e": "for bold and",
  "para parágrafo.": "for a paragraph.",
  "Adicionar Métodos de Pagamento:": "Add payment methods:",
  "Escolha um Método": "Choose a method",
  "Ficheiro:": "File:",
  "Enviar": "Send",
  "Ocultar palavra-passe": "Hide password",
  "Mostrar palavra-passe": "Show password",
  "As palavras-passe não coincidem.": "Passwords do not match.",
  "Crie uma conta com acesso à gestão global de formulários, utilizadores e atividade da plataforma.": "Create an account with access to global management of forms, users and platform activity.",
  "Criar administrador": "Create administrator",
  "Escolha uma imagem JPG, PNG, BMP ou WebP até 5 MB.": "Choose a JPG, PNG, BMP or WebP image up to 5 MB.",
  "Não foi possível guardar a fotografia.": "Could not save the photo.",
  "As novas palavras-passe não coincidem.": "The new passwords do not match.",
  "A palavra-passe foi alterada com sucesso.": "The password was changed successfully.",
  "Fotografia de perfil": "Profile photo",
  "Clique na câmara para alterar a fotografia. Máximo 5 MB.": "Click the camera to change the photo. Maximum 5 MB.",
  "Palavra-passe atual": "Current password",
  "N.º de conta": "Account no.",
  "Estado da conta": "Account status",
  "Nenhum utilizador encontrado": "No users found",
  "Acesso criado com sucesso.": "Access created successfully.",
  "Acesso removido.": "Access removed.",
  "Novo utilizador": "New user",
  "utilizadores": "users",
  "Remover acesso": "Remove access",
  "Novo acesso": "New access",
  "Criar acesso": "Create access",
  "Map data &copy; <a href=\"https://www.openstreetmap.org/\">OpenStreetMap</a> contributors": "Map data &copy; <a href=\"https://www.openstreetmap.org/\">OpenStreetMap</a> contributors",
  "Não foi possível enviar o formulário. Tenta novamente.": "Could not submit the form. Please try again.",
  "Selecione pelo menos uma unidade de um artigo antes de continuar.": "Select at least one unit of an item before continuing.",
  "O valor mínimo para pagamento é 0,05 €.": "The minimum payment amount is €0.05.",
  "Formulário seguro": "Secure form",
  "Enviar formulário": "Send form",
  "Inscrição Workshop Local": "Local workshop registration",
  "Escolha o valor do seu donativo e preencha os seus dados.": "Choose your donation amount and enter your details.",
  "Deixe os seus dados e entraremos em contacto consigo.": "Leave your details and we will contact you.",
  "O formulário": "The form",
  "O nome do formulário é obrigatório.": "The name of the form is required.",
  "sem nome": "without name",
  "Começa com uma base simples": "Start with a simple base",
  "Preenche automaticamente nome, descrição e pagamentos.": "Automatically fills in the name, description and payments.",
  "Pagamentos online opcionais": "Optional online payments",
  "Podes criar e testar o formulário apenas com Numerário. A Chave API é necessária para Multibanco, MB WAY, Cartão de Crédito, Google Pay ou Apple Pay.": "You can create and test the form using Cash only. The API key is required for Multibanco, MB WAY, Credit Card, Google Pay or Apple Pay.",
  "Ex.: Inscrição Workshop Local": "Ex.: Registration Workshop Location",
  "(opcional)": "(optional)",
  "Chave API Eupago obrigatória": "Eupago API key required",
  "Necessária apenas para pagamentos online": "Required only for online payments",
  "Selecionaste um método de pagamento online; tens de indicar a Chave API.": "You selected an online payment method; you must provide the API key.",
  "Sem Chave API, o formulário funciona com Numerário e recolha de respostas.": "Without an API key, the form works with Cash and reply collection.",
  "Texto introdutório apresentado no formulário público.": "Introductory text shown on the public form.",
  "Criar e abrir editor": "Create and open editor",
  "Formulário criado com sucesso": "Form created successfully",
  "” está guardado e já aparece na lista de formulários.": "” has been saved and now appears in the forms list.",
  "Fechar mensagem de sucesso": "Close success message",
  "Atualizar": "Update",
  "Atenção às notificações de pagamento": "Payment notification warning",
  "Data Criação": "Creation date",
  "Definições Formulário": "Form settings",
  "Nome:": "Name:",
  "Obrigatória para Multibanco, MB WAY, Cartão de Crédito, Google Pay ou Apple Pay.": "Required for Multibanco, MB WAY, Credit Card, Google Pay or Apple Pay.",
  "Sem Chave API, podes usar Numerário e recolher respostas.": "Without an API key, you can use Cash and collect replies.",
  "Fechar mensagem": "Close message",
  "Remover este campo?": "Remove this field?",
  "O campo": "The field",
  "Remover campo": "Remove field",
  "Nome, email, telefone": "Name, email, phone",
  "Data do evento ou marcação": "Event or booking date",
  "Lista de opções": "Options list",
  "Valor livre": "Free amount",
  "Informação": "Information",
  "Preenche os dados abaixo para reservares a tua inscrição.": "Fill in the details below to reserve your registration.",
  "Nome completo": "Full name",
  "Ex.: nome@exemplo.pt": "Ex.: name@example.pt",
  "Data pretendida": "Preferred date",
  "Seleciona a data do workshop": "Select the workshop date",
  "Bilhete do workshop": "Workshop ticket",
  "Seleciona a quantidade de bilhetes": "Select the number of tickets",
  "Preenche os teus dados e entraremos em contacto contigo.": "Enter your details and we will contact you.",
  "Formulário rápido com identificação e valor livre.": "Quick form with identification and a free amount.",
  "Fazer um donativo": "Make a donation",
  "Valor do donativo": "Donation amount",
  "Indica o valor que pretendes doar": "Enter the amount you want to donate",
  "A criar e preencher o modelo. Aguarda um instante...": "Creating and filling the template. Please wait a moment...",
  "Modelo criado e preenchido. Já podes utilizá-lo ou ajustar os campos.": "Template created and filled in. You can now use it or adjust the fields.",
  "Pesquisar campos": "Search fields",
  "Pesquisar campos…": "Search fields…",
  "Pré-visualização em telemóvel": "Mobile preview",
  "campo": "field",
  "campos": "fields",
  "Começa com um modelo": "Start with a template",
  "Editar campo": "Edit field",
  "Estado do formulário": "Status of the form",
  "Incluído": "Included",
  "Opcional": "Optional",
  "Está pronto para configurares as definições, os pagamentos opcionais e a publicação.": "It is ready for you to configure settings, optional payments and publishing.",
  "+ Campo de donativo": "+ Donation field",
  "Campo removido": "Field removed",
  "Preencha os seus dados e confirme o pedido.": "Enter your details and confirm the request.",
  "Inscrição": "Registration",
  "A pré-visualização atualiza imediatamente. Guarda para aplicar o tema ao formulário público.": "The preview updates immediately. Save to apply the theme to the public form.",
  "Preenche o nome do formulário.": "Fill the name of the form.",
  "Indica uma cor personalizada válida.": "Enter a valid custom colour.",
  "Revê os dados do formulário.": "Review the form details.",
  "O valor máximo permitido é 9999.": "The maximum allowed value is 9999.",
  "A configuração Webhooks 2.0 foi sincronizada e confirmada pela Eupago.": "The Webhooks 2.0 configuration was synchronized and confirmed by Eupago.",
  "O callback não pôde ser configurado.": "The callback could not be configured.",
  "Exemplo: Inscrição Workshop Local": "Example: Local workshop registration",
  "Obrigatória porque selecionaste um método de pagamento online.": "Required because you selected an online payment method.",
  "Necessária apenas para Multibanco, MB WAY ou Cartão de Crédito.": "Required only for Multibanco, MB WAY or Credit Card.",
  "Opcional para formulários com Numerário": "Optional for forms with Cash",
  "Aparência do formulário": "Form appearance",
  "Escolhe um tema pronto a usar ou aplica a cor da tua marca.": "Choose a ready-to-use theme or apply your brand colour.",
  "Cor da marca (HEX)": "Brand colour (HEX)",
  "Usada apenas em botões, seleções e destaques.": "Used only for buttons, selections and highlights.",
  "Escolher cor da marca": "Choose brand colour",
  "Usa o formato #RRGGBB, por exemplo #2563EB.": "Use the #RRGGBB format, for example #2563EB.",
  "Base do formulário": "Form base",
  "Mantém a leitura confortável em fundo claro ou escuro.": "Keeps text comfortable to read on a light or dark background.",
  "Contraste automático aprovado": "Automatic contrast approved",
  "O texto do botão será": "The button text will be",
  "escuro": "dark",
  "PT — Português": "PT — Portuguese",
  "ES — Espanhol": "ES — Spanish",
  "EN — Inglês": "EN — English",
  "Sincronização manual da configuração do canal Eupago associado a este formulário.": "Manual synchronization of the Eupago channel configuration associated with this form.",
  "A configuração ainda não foi obtida da Eupago.": "The configuration has not yet been retrieved from Eupago.",
  "A sincronização de Webhooks 2.0 fica indisponível sem Chave API. O formulário pode continuar a ser usado com Numerário.": "Webhooks 2.0 synchronization is unavailable without an API key. The form can still be used with Cash.",
  "Sincronizar com informação do canal": "Synchronize with channel information",
  "Prazo de pagamento Multibanco": "Multibanco payment deadline",
  "Limitação de stock": "Stock limitation",
  "Reduzir stock quando a compra estiver": "Reduce stock when the purchase is",
  "Só funciona se o cliente preencher email no pagamento.": "Only works if the customer enters an email during payment.",
  "Imagem e finalização": "Image and completion",
  "Error fetching data": "Error fetching data",
  "Formulário finalizado com sucesso. A regressar à lista...": "Form completed successfully. Returning to the list...",
  "Imagem enviada com sucesso.": "Image uploaded successfully.",
  "Imagem removida do formulário e do armazenamento.": "Image removed from the form and storage.",
  "Imagem do formulário": "Image of the form",
  "Remover": "Remove",
  "Enviar imagem": "Send image",
  "Imagem opcional": "Image optional",
  "Publique e partilhe cada formulário através de um endereço único.": "Publish and share each form through a unique address.",
  "Localização de eventos": "Location of events",
  "Crie a sua conta": "Create your account",
  "Desenhe o formulário": "Design the form",
  "Escolha campos, pagamentos, stock e regras sem escrever código.": "Choose fields, payments, stock and rules without writing code.",
  "Envie o link e consulte respostas e referências em tempo real.": "Send the link and view replies and references in real time.",
  "Criar conta": "Create account",
  "Saiba mais": "Learn more",
  "Criar o primeiro formulário": "Create the first form",
  "Configuração rápida": "Quick setup",
  "Pré-visualização da plataforma Formulários": "Forms preview",
  "Destaques": "Highlights",
  "tipos de formulário": "form types",
  "sempre disponível": "always available",
  "Uma plataforma completa": "A complete platform",
  "A palavra-passe deve ter pelo menos 8 caracteres, incluindo maiúscula, minúscula, número e símbolo.": "The password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number and a symbol.",
  "Já existe uma conta registada com este email.": "An account is already registered with this email.",
  "A palavra-passe não cumpre os requisitos de segurança.": "The password does not meet the security requirements.",
  "Não foi possível criar a conta. Confirme os dados e tente novamente.": "Could not create the account. Check the details and try again.",
  "Nova conta": "New account",
  "Crie a sua conta com email e palavra-passe.": "Create your account with an email and password.",
  "Mínimo de 8 caracteres, com maiúscula, minúscula, número e símbolo.": "At least 8 characters, with an uppercase letter, a lowercase letter, a number and a symbol.",
  "Já tem conta? Entrar": "Already have an account? Sign in",
  "Não preenchido": "Not filled",
  "Não foi possível copiar o identificador:": "Could not copy the identifier:",
  "Não foi possível carregar os detalhes da resposta.": "Could not load the reply details.",
  "Gestão de dados": "Management of data",
  "Atualizar lista": "Update list",
  "Pagamentos concluídos": "Payments completed",
  "Pagamentos pendentes": "Payments pending",
  "Tentar novamente": "Try again",
  "Nenhuma resposta encontrada": "No replies found",
  "Ocultar informação": "Hide information",
  "Email para notificações": "Email for notifications",
  "Não existem campos associados a esta resposta.": "There are no fields associated with this reply.",
  "Campo": "Field",
  "Não existem itens associados a esta resposta.": "There are no items associated with this reply.",
  "Valor:": "Value:",
  "Pagamento original": "Original payment",
  "Palavra-passe alterada com sucesso": "Password changed successfully",
  "Definir nova palavra-passe": "Set new password",
  "Escolha uma imagem JPG, PNG, BMP ou WebP.": "Choose a JPG, PNG, BMP or WebP image.",
  "A fotografia não pode exceder 5 MB.": "The photo cannot exceed 5 MB."
});

Object.assign(exactES, {
  "comentário": "comentario",
  "validação": "validación",
  "seleção": "selección",
  "avaliação": "valoración",
  "preço": "precio",
  "elemento": "elemento",
  "Sugestão": "Sugerencia",
  "A Chave API da Eupago é obrigatória para pagamentos online.": "La clave API de Eupago es obligatoria para los pagos online.",
  "Portugal": "Portugal",
  "Espanha": "España",
  "Itália": "Italia",
  "Tem a certeza que quer apagar este formulário?": "¿Seguro que quiere eliminar este formulario?",
  "Selecionar uma opção": "Seleccionar una opción",
  "estrela": "estrella",
  "estrelas": "estrellas",
  "Campo Obrigatório:": "Campo obligatorio:",
  "Sucesso:": "Éxito:",
  "Dados guardados com sucesso!": "¡Datos guardados correctamente!",
  "Adicionar Opção": "Añadir opción",
  "Editar Doação": "Editar donación",
  "caixa de texto": "cuadro de texto",
  "escolha múltipla": "elección múltiple",
  "data": "fecha",
  "informação": "información",
  "doação": "donación",
  "A legenda é obrigatória.": "La etiqueta es obligatoria.",
  "O preço mínimo por artigo é 0,05 €.": "El precio mínimo por artículo es 0,05 €.",
  "Introduza um valor válido.": "Introduzca un valor válido.",
  "formulário": "formulario",
  "Elemento guardado com sucesso.": "Elemento guardado correctamente.",
  "Conteúdo": "Contenido",
  "Definições do campo": "Configuración del campo",
  "Opcional, por exemplo ^[0-9]+$": "Opcional, por ejemplo ^[0-9]+$",
  "Valor (€) *": "Valor (€) *",
  "Adicionar": "Añadir",
  "Legenda do campo": "Etiqueta del campo",
  "Valor mínimo: 0,05 €.": "Valor mínimo: 0,05 €.",
  "Elemento atualizado com sucesso!": "¡Elemento actualizado correctamente!",
  "Máximo de 2000 caracteres": "Máximo de 2000 caracteres",
  "O título é obrigatório.": "El título es obligatorio.",
  "Editar título do formulário": "Editar título del formulario",
  "Define o título principal e o subtítulo que aparecem no formulário público.": "Define el título principal y el subtítulo que aparecen en el formulario público.",
  "Texto do título": "Texto del título",
  "Ex.: Inscrição no workshop": "Ej.: Inscripción en el taller",
  "Usa uma frase curta e clara. Este texto aparece em destaque.": "Usa una frase corta y clara. Este texto aparece destacado.",
  "Voltar": "Volver",
  "Título da secção": "Título de la sección",
  "Selecionar": "Seleccionar",
  "Data": "Fecha",
  "Ainda não é cliente Eupago?": "¿Todavía no es cliente de Eupago?",
  "hover:text-green-claro": "hover:text-green-claro",
  "Crie os seus formulários sem a necessidade de qualquer conhecimento em programação": "Cree sus formularios sin necesidad de conocimientos de programación.",
  "Partilhe os seus formulários com os seus clientes de forma simples e rápida": "Comparta sus formularios con sus clientes de forma sencilla y rápida.",
  "Com a plataforma Formulários consegui criar os meus formulários rapidamente e partilhar com todos os meus clientes que facilmente os preencheram e pagaram de forma segura": "Con Formularios pude crear mis formularios rápidamente y compartirlos con todos mis clientes, que pudieron completarlos fácilmente y pagar de forma segura.",
  "Ocorreu um erro; tente novamente com outro método de pagamento.": "Se produjo un error; inténtelo de nuevo con otro método de pago.",
  "Ocorreu um erro. Por favor tente novamente.": "Se produjo un error. Inténtelo de nuevo.",
  "Introduza os 9 algarismos do número português.": "Introduzca los 9 dígitos del número portugués.",
  "Introduza os 9 algarismos do número espanhol.": "Introduzca los 9 dígitos del número español.",
  "Introduza entre 6 e 11 algarismos do número italiano.": "Introduzca entre 6 y 11 dígitos del número italiano.",
  "Formulário preenchido com sucesso!": "¡Formulario completado correctamente!",
  "Donativos": "Donaciones",
  "no valor de": "por un importe de",
  "O pagamento foi concluído com sucesso.": "El pago fue completado correctamente.",
  "Pagamento Multibanco": "Pago Multibanco",
  "Data limite": "Fecha límite",
  "Texto que será exibido como título do campo no formulário.": "Texto que se mostrará como título del campo en el formulario.",
  "para o adicionar à lista.": "para añadirlo a la lista.",
  "Email de informação de pagamento": "Email de información de pago",
  "NIF português": "NIF portugués",
  "Validação mais genérica.": "Validación más genérica.",
  "Contacto telefónico com indicativo": "Contacto telefónico con prefijo",
  "Editar campo de texto": "Editar campo de texto",
  "Dados guardados com sucesso.": "Datos guardados correctamente.",
  "Identificação do campo": "Identificación del campo",
  "Tipo de validação": "Tipo de validación",
  "Texto de exemplo dentro do campo": "Texto de ejemplo dentro del campo",
  "Se cancelares um campo recém-criado sem preencher nada, ele será removido automaticamente.": "Si cancela un campo recién creado sin rellenar nada, se eliminará automáticamente.",
  "Texto principal exibido como cabeçalho no formulário.": "Texto principal mostrado como encabezado del formulario.",
  "Verde da marca e superfícies claras.": "Verde de marca y superficies claras.",
  "Claro": "Claro",
  "Escuro": "Oscuro",
  "Fundo escuro com dourado intenso e texto claro.": "Fondo oscuro con dorado intenso y texto claro.",
  "Espaço, conteúdo e contornos discretos.": "Espaciado limpio, contenido y bordes discretos.",
  "Escolhe o HEX dos botões e destaques.": "Elige el HEX de los botones y destacados.",
  "Gerir formulários": "Gestionar formularios",
  "Contas com acesso à plataforma": "Cuentas con acceso a la plataforma",
  "Gerir utilizadores": "Gestionar usuarios",
  "Novo formulário": "Nuevo formulario",
  "Escolha Múltipla": "Elección múltiple",
  "Linha de Divisão": "Línea divisoria",
  "Não foi possível criar o formulário.": "No se pudo crear el formulario.",
  "Criar formulário": "Crear formulario",
  "formulários": "formularios",
  "Editar campos": "Editar campos",
  "Ver respostas": "Ver respuestas",
  "Apagar formulário": "Eliminar formulario",
  "Nenhum formulário encontrado": "No se encontró ningún formulario",
  "Altere a pesquisa ou crie um novo formulário.": "Cambie la búsqueda o cree un nuevo formulario.",
  "de": "de",
  "Apagar formulário?": "Eliminar formulario?",
  "Apagar": "Eliminar",
  "O formulário só será guardado depois de indicar um nome.": "El formulario solo se guardará después de indicar un nombre.",
  "Ex.: Inscrição no evento": "Ej.: Inscripción en el evento",
  "Criar e continuar": "Crear y continuar",
  "para negrito e": "para negrita y",
  "para parágrafo.": "para párrafo.",
  "Adicionar Métodos de Pagamento:": "Añadir métodos de pago:",
  "Escolha um Método": "Elija un método",
  "Ficheiro:": "Archivo:",
  "Enviar": "Enviar",
  "Ocultar palavra-passe": "Ocultar contraseña",
  "Mostrar palavra-passe": "Mostrar contraseña",
  "As palavras-passe não coincidem.": "Las contraseñas no coinciden.",
  "Crie uma conta com acesso à gestão global de formulários, utilizadores e atividade da plataforma.": "Cree una cuenta con acceso a la gestión global de formularios, usuarios y actividad de la plataforma.",
  "Criar administrador": "Crear administrador",
  "Escolha uma imagem JPG, PNG, BMP ou WebP até 5 MB.": "Elija una imagen JPG, PNG, BMP o WebP de hasta 5 MB.",
  "Não foi possível guardar a fotografia.": "No se pudo guardar la foto.",
  "As novas palavras-passe não coincidem.": "Las nuevas contraseñas no coinciden.",
  "A palavra-passe foi alterada com sucesso.": "La contraseña fue cambiada correctamente.",
  "Fotografia de perfil": "Foto de perfil",
  "Clique na câmara para alterar a fotografia. Máximo 5 MB.": "Haga clic en la cámara para cambiar la foto. Máximo 5 MB.",
  "Palavra-passe atual": "Contraseña actual",
  "N.º de conta": "N.º de cuenta",
  "Estado da conta": "Estado de la cuenta",
  "Nenhum utilizador encontrado": "No se encontró ningún usuario",
  "Acesso criado com sucesso.": "Acceso creado correctamente.",
  "Acesso removido.": "Acceso eliminado.",
  "Novo utilizador": "Nuevo usuario",
  "utilizadores": "usuarios",
  "Remover acesso": "Eliminar acceso",
  "Novo acesso": "Nuevo acceso",
  "Criar acesso": "Crear acceso",
  "Map data &copy; <a href=\"https://www.openstreetmap.org/\">OpenStreetMap</a> contributors": "Map data &copy; <a href=\"https://www.openstreetmap.org/\">OpenStreetMap</a> contributors",
  "Não foi possível enviar o formulário. Tenta novamente.": "No se pudo enviar el formulario. Inténtelo de nuevo.",
  "Selecione pelo menos uma unidade de um artigo antes de continuar.": "Seleccione al menos una unidad de un artículo antes de continuar.",
  "O valor mínimo para pagamento é 0,05 €.": "El importe mínimo de pago es 0,05 €.",
  "Formulário seguro": "Formulario seguro",
  "Enviar formulário": "Enviar formulario",
  "Inscrição Workshop Local": "Inscripción en taller local",
  "Escolha o valor do seu donativo e preencha os seus dados.": "Elija el importe de su donación y complete sus datos.",
  "Deixe os seus dados e entraremos em contacto consigo.": "Deje sus datos y nos pondremos en contacto con usted.",
  "O formulário": "El formulario",
  "O nome do formulário é obrigatório.": "El nombre del formulario es obligatorio.",
  "sem nome": "sin nombre",
  "Começa com uma base simples": "Empiece con una base sencilla",
  "Preenche automaticamente nome, descrição e pagamentos.": "Rellena automáticamente el nombre, la descripción y los pagos.",
  "Pagamentos online opcionais": "Pagos online opcionales",
  "Podes criar e testar o formulário apenas com Numerário. A Chave API só é necessária para Multibanco, MB WAY ou Cartão de Crédito.": "Puede crear y probar el formulario solo con Efectivo. La clave API solo es necesaria para Multibanco, MB WAY o Tarjeta de Crédito.",
  "Ex.: Inscrição Workshop Local": "Ex.: Inscripción Workshop Ubicación",
  "(opcional)": "(opcional)",
  "Chave API Eupago obrigatória": "Clave API de Eupago obligatoria",
  "Necessária apenas para pagamentos online": "Necesaria solo para pagos online",
  "Selecionaste um método de pagamento online; tens de indicar a Chave API.": "Ha seleccionado un método de pago online; debe indicar la clave API.",
  "Sem Chave API, o formulário funciona com Numerário e recolha de respostas.": "Sin clave API, el formulario funciona con Efectivo y recogida de respuestas.",
  "Texto introdutório apresentado no formulário público.": "Texto introductorio mostrado en el formulario público.",
  "Criar e abrir editor": "Crear y abrir editor",
  "Formulário criado com sucesso": "Formulario creado correctamente",
  "” está guardado e já aparece na lista de formulários.": "” se ha guardado y ya aparece en la lista de formularios.",
  "Fechar mensagem de sucesso": "Cerrar mensaje de éxito",
  "Atualizar": "Actualizar",
  "Atenção às notificações de pagamento": "Aviso sobre notificaciones de pago",
  "Data Criação": "Fecha de creación",
  "Definições Formulário": "Configuración del formulario",
  "Nome:": "Nombre:",
  "Obrigatória para Multibanco, MB WAY, Cartão de Crédito, Google Pay ou Apple Pay.": "Obligatoria para Multibanco, MB WAY, Tarjeta de Crédito, Google Pay o Apple Pay.",
  "Sem Chave API, podes usar Numerário e recolher respostas.": "Sin clave API, puede usar Efectivo y recoger respuestas.",
  "Fechar mensagem": "Cerrar mensaje",
  "Remover este campo?": "Eliminar este campo?",
  "O campo": "El campo",
  "Remover campo": "Eliminar campo",
  "Nome, email, telefone": "Nombre, email, teléfono",
  "Data do evento ou marcação": "Fecha del evento o reserva",
  "Lista de opções": "Lista de opciones",
  "Valor livre": "Importe libre",
  "Informação": "Información",
  "Preenche os dados abaixo para reservares a tua inscrição.": "Complete los datos siguientes para reservar su inscripción.",
  "Nome completo": "Nombre completo",
  "Ex.: nome@exemplo.pt": "Ex.: nombre@ejemplo.pt",
  "Data pretendida": "Fecha deseada",
  "Seleciona a data do workshop": "Seleccione la fecha del taller",
  "Bilhete do workshop": "Entrada del taller",
  "Seleciona a quantidade de bilhetes": "Seleccione la cantidad de entradas",
  "Preenche os teus dados e entraremos em contacto contigo.": "Complete sus datos y nos pondremos en contacto con usted.",
  "Formulário rápido com identificação e valor livre.": "Formulario rápido con identificación e importe libre.",
  "Fazer um donativo": "Hacer una donación",
  "Valor do donativo": "Importe de la donación",
  "Indica o valor que pretendes doar": "Indique el importe que desea donar",
  "A criar e preencher o modelo. Aguarda um instante...": "Creando y rellenando la plantilla. Espere un momento...",
  "Modelo criado e preenchido. Já podes utilizá-lo ou ajustar os campos.": "Plantilla creada y rellenada. Ya puede usarla o ajustar los campos.",
  "Pesquisar campos": "Buscar campos",
  "Pesquisar campos…": "Buscar campos…",
  "Pré-visualização em telemóvel": "Vista previa en móvil",
  "campo": "campo",
  "campos": "campos",
  "Começa com um modelo": "Empiece con una plantilla",
  "Editar campo": "Editar campo",
  "Estado do formulário": "Estado del formulario",
  "Incluído": "Incluido",
  "Opcional": "Opcional",
  "Está pronto para configurares as definições, os pagamentos opcionais e a publicação.": "Está listo para configurar los ajustes, los pagos opcionales y la publicación.",
  "+ Campo de donativo": "+ Campo de donación",
  "Campo removido": "Campo eliminado",
  "Preencha os seus dados e confirme o pedido.": "Complete sus datos y confirme el pedido.",
  "Inscrição": "Inscripción",
  "A pré-visualização atualiza imediatamente. Guarda para aplicar o tema ao formulário público.": "La vista previa se actualiza inmediatamente. Guarde para aplicar el tema al formulario público.",
  "Preenche o nome do formulário.": "Completa el nombre del formulario.",
  "Indica uma cor personalizada válida.": "Indique un color personalizado válido.",
  "Revê os dados do formulário.": "Revise los datos del formulario.",
  "O valor máximo permitido é 9999.": "El valor máximo permitido es 9999.",
  "A configuração Webhooks 2.0 foi sincronizada e confirmada pela Eupago.": "La configuración de Webhooks 2.0 se sincronizó y fue confirmada por Eupago.",
  "O callback não pôde ser configurado.": "No se pudo configurar el callback.",
  "Exemplo: Inscrição Workshop Local": "Ejemplo: Inscripción en taller local",
  "Obrigatória porque selecionaste um método de pagamento online.": "Obligatoria porque ha seleccionado un método de pago online.",
  "Necessária apenas para Multibanco, MB WAY ou Cartão de Crédito.": "Necesaria solo para Multibanco, MB WAY o Tarjeta de Crédito.",
  "Opcional para formulários com Numerário": "Opcional para formularios con Efectivo",
  "Aparência do formulário": "Apariencia del formulario",
  "Escolhe um tema pronto a usar ou aplica a cor da tua marca.": "Elija un tema listo para usar o aplique el color de su marca.",
  "Cor da marca (HEX)": "Color de marca (HEX)",
  "Usada apenas em botões, seleções e destaques.": "Se usa solo en botones, selecciones y elementos destacados.",
  "Escolher cor da marca": "Elegir color de marca",
  "Usa o formato #RRGGBB, por exemplo #2563EB.": "Use el formato #RRGGBB, por ejemplo #2563EB.",
  "Base do formulário": "Base del formulario",
  "Mantém a leitura confortável em fundo claro ou escuro.": "Mantiene una lectura cómoda sobre fondo claro u oscuro.",
  "Contraste automático aprovado": "Contraste automático aprobado",
  "O texto do botão será": "El texto del botón será",
  "escuro": "oscuro",
  "PT — Português": "PT — Portugués",
  "ES — Espanhol": "ES — Español",
  "EN — Inglês": "EN — Inglés",
  "Sincronização manual da configuração do canal Eupago associado a este formulário.": "Sincronización manual de la configuración del canal Eupago asociado a este formulario.",
  "A configuração ainda não foi obtida da Eupago.": "La configuración todavía no se ha obtenido de Eupago.",
  "A sincronização de Webhooks 2.0 fica indisponível sem Chave API. O formulário pode continuar a ser usado com Numerário.": "La sincronización de Webhooks 2.0 no está disponible sin clave API. El formulario puede seguir utilizándose con Efectivo.",
  "Sincronizar com informação do canal": "Sincronizar con la información del canal",
  "Prazo de pagamento Multibanco": "Plazo de pago Multibanco",
  "Limitação de stock": "Limitación de stock",
  "Reduzir stock quando a compra estiver": "Reducir stock cuando la compra esté",
  "Só funciona se o cliente preencher email no pagamento.": "Solo funciona si el cliente introduce el email durante el pago.",
  "Imagem e finalização": "Imagen y finalización",
  "Error fetching data": "Error al obtener los datos",
  "Formulário finalizado com sucesso. A regressar à lista...": "Formulario finalizado correctamente. Volviendo a la lista...",
  "Imagem enviada com sucesso.": "Imagen subida correctamente.",
  "Imagem removida do formulário e do armazenamento.": "Imagen eliminada del formulario y del almacenamiento.",
  "Imagem do formulário": "Imagen del formulario",
  "Remover": "Eliminar",
  "Enviar imagem": "Enviar imagen",
  "Imagem opcional": "Imagen opcional",
  "Publique e partilhe cada formulário através de um endereço único.": "Publique y comparta cada formulario mediante una dirección única.",
  "Localização de eventos": "Ubicación de eventos",
  "Crie a sua conta": "Cree su cuenta",
  "Desenhe o formulário": "Diseñe el formulario",
  "Escolha campos, pagamentos, stock e regras sem escrever código.": "Elija campos, pagos, stock y reglas sin escribir código.",
  "Envie o link e consulte respostas e referências em tempo real.": "Envíe el enlace y consulte respuestas y referencias en tiempo real.",
  "Criar conta": "Crear cuenta",
  "Saiba mais": "Más información",
  "Criar o primeiro formulário": "Crear el primer formulario",
  "Configuração rápida": "Configuración rápida",
  "Pré-visualização da plataforma Formulários": "Vista previa de Formularios",
  "Destaques": "Destacados",
  "tipos de formulário": "tipos de formulario",
  "sempre disponível": "siempre disponible",
  "Uma plataforma completa": "Una plataforma completa",
  "A palavra-passe deve ter pelo menos 8 caracteres, incluindo maiúscula, minúscula, número e símbolo.": "La contraseña debe tener al menos 8 caracteres e incluir una mayúscula, una minúscula, un número y un símbolo.",
  "Já existe uma conta registada com este email.": "Ya existe una cuenta registrada con este email.",
  "A palavra-passe não cumpre os requisitos de segurança.": "La contraseña no cumple los requisitos de seguridad.",
  "Não foi possível criar a conta. Confirme os dados e tente novamente.": "No se pudo crear la cuenta. Revise los datos e inténtelo de nuevo.",
  "Nova conta": "Nueva cuenta",
  "Crie a sua conta com email e palavra-passe.": "Cree su cuenta con email y contraseña.",
  "Mínimo de 8 caracteres, com maiúscula, minúscula, número e símbolo.": "Mínimo 8 caracteres, con una mayúscula, una minúscula, un número y un símbolo.",
  "Já tem conta? Entrar": "¿Ya tiene cuenta? Iniciar sesión",
  "Não preenchido": "No completado",
  "Não foi possível copiar o identificador:": "No se pudo copiar el identificador:",
  "Não foi possível carregar os detalhes da resposta.": "No se pudieron cargar los detalles de la respuesta.",
  "Gestão de dados": "Gestión de datos",
  "Atualizar lista": "Actualizar lista",
  "Pagamentos concluídos": "Pagos completados",
  "Pagamentos pendentes": "Pagos pendientes",
  "Tentar novamente": "Intentar de nuevo",
  "Nenhuma resposta encontrada": "No se encontró ninguna respuesta",
  "Ocultar informação": "Ocultar información",
  "Email para notificações": "Email para notificaciones",
  "Não existem campos associados a esta resposta.": "No hay campos asociados a esta respuesta.",
  "Campo": "Campo",
  "Não existem itens associados a esta resposta.": "No hay elementos asociados a esta respuesta.",
  "Valor:": "Valor:",
  "Pagamento original": "Pago original",
  "Palavra-passe alterada com sucesso": "Contraseña cambiada correctamente",
  "Definir nova palavra-passe": "Definir nueva contraseña",
  "Escolha uma imagem JPG, PNG, BMP ou WebP.": "Elija una imagen JPG, PNG, BMP o WebP.",
  "A fotografia não pode exceder 5 MB.": "La foto no puede superar los 5 MB."
});

const exactPT: Record<string, string> = {
  "An error occurred while trying to reset the password.": "Ocorreu um erro ao tentar recuperar a palavra-passe.",
  "Password must contain at least one capital letter and one number.": "A palavra-passe deve conter pelo menos uma letra maiúscula e um número.",
  "Create a New User Profile": "Criar novo perfil de utilizador",
  "Create New User": "Criar novo utilizador",
  "CREATE USER": "CRIAR UTILIZADOR",
  "First Name": "Nome",
  "Last Name": "Apelido",
  "Contact Number": "Número de contacto",
  "Address 1": "Morada 1",
  "Address 2": "Morada 2",
  "Empty sync response": "Resposta de sincronização vazia",
  "Loading": "A carregar",
  "Logout": "Sair",
  "Enter": "Introduzir",
};

Object.assign(exactES, {
  "An error occurred while trying to reset the password.": "Se produjo un error al intentar restablecer la contraseña.",
  "Password must contain at least one capital letter and one number.": "La contraseña debe contener al menos una letra mayúscula y un número.",
  "Create a New User Profile": "Crear un nuevo perfil de usuario",
  "Create New User": "Crear nuevo usuario",
  "CREATE USER": "CREAR USUARIO",
  "First Name": "Nombre",
  "Last Name": "Apellidos",
  "Contact Number": "Número de contacto",
  "Address 1": "Dirección 1",
  "Address 2": "Dirección 2",
  "Empty sync response": "Respuesta de sincronización vacía",
  "Loading": "Cargando",
  "Logout": "Cerrar sesión",
  "Enter": "Introducir",
});

const phraseEN: Array<[RegExp, string]> = [
  [/^\(Sugestão:\s*(.+?)\s*€\)$/i, '(Suggestion: $1 €)'],
  [/^Valor do donativo (.+)$/i, 'Donation amount $1'],
  [/^Quantidade de (.+)$/i, 'Quantity of $1'],
  [/^Responsável por (.+)$/i, 'Owner of $1'],
  [/^(\d+) com acesso$/i, '$1 with access'],
  [/^Preencha o campo (.+) corretamente$/i, 'Fill in the $1 field correctly'],
  [/^Imagem de (.+)$/i, 'Image of $1'],
  [/^Erro HTTP (.+)$/i, 'HTTP error $1'],
  [/^Imagem do formulário (.+)$/i, 'Form image $1'],
  [/^Não foi possível configurar o campo "(.+)"\.$/i, 'Could not configure the "$1" field.'],
  [/^respostas-(.+)\.csv$/i, 'replies-$1.csv'],
  [/^Pedido de reembolso enviado(.*)\.$/i, 'Refund request sent$1.'],
  [/^Pedir reembolso · (.+) disponível$/i, 'Request refund · $1 available'],
  [/^(.+?) copiado\.$/gi, '$1 copied.'],
  [/O formulário “([^”]+)” deixou de conseguir validar notificações da Eupago\./gi, 'The form “$1” is unable to validate Eupago notifications.'],
  [/formulários deixaram de conseguir validar notificações da Eupago\./gi, 'forms are unable to validate Eupago notifications.'],
  [/Aumentar quantidade de/gi, 'Increase quantity of'],
  [/Diminuir quantidade de/gi, 'Decrease quantity of'],
  [/Copiar ID/gi, 'Copy ID'],
  [/Falha ao enviar imagem\. Código:/gi, 'Image upload failed. Code:'],
  [/Pedir reembolso ·/gi, 'Request refund ·'],
  [/Versão/gi, 'Version'],
  [/palavra-passe/gi, 'password'],
  [/método de pagamento/gi, 'payment method'],
  [/métodos de pagamento/gi, 'payment methods'],
  [/campo de preço/gi, 'price field'],
  [/campo de doação/gi, 'donation field'],
  [/formulário público/gi, 'public form'],
  [/formulários públicos/gi, 'public forms'],
  [/chave API/gi, 'API key'],
  [/data de início/gi, 'start date'],
  [/data de fim/gi, 'end date'],
  [/por favor/gi, 'please'],
  [/ainda não/gi, 'not yet'],
  [/com sucesso/gi, 'successfully'],
  [/de forma simples/gi, 'simply'],
  [/de pagamento/gi, 'payment'],
  [/do formulário/gi, 'of the form'],
  [/da plataforma/gi, 'of the platform'],
  [/do utilizador/gi, 'of the user'],
  [/para continuar/gi, 'to continue'],
  [/para avançar/gi, 'to continue'],
  [/não pode/gi, 'cannot'],
  [/não existem/gi, 'there are no'],
  [/não existe/gi, 'does not exist'],
  [/é obrigatória/gi, 'is required'],
  [/é obrigatório/gi, 'is required'],
  [/deve ter/gi, 'must have'],
];

const phraseES: Array<[RegExp, string]> = [
  [/^\(Sugestão:\s*(.+?)\s*€\)$/i, '(Sugerencia: $1 €)'],
  [/^Valor do donativo (.+)$/i, 'Importe de la donación $1'],
  [/^Quantidade de (.+)$/i, 'Cantidad de $1'],
  [/^Responsável por (.+)$/i, 'Responsable de $1'],
  [/^(\d+) com acesso$/i, '$1 con acceso'],
  [/^Preencha o campo (.+) corretamente$/i, 'Complete correctamente el campo $1'],
  [/^Imagem de (.+)$/i, 'Imagen de $1'],
  [/^Erro HTTP (.+)$/i, 'Error HTTP $1'],
  [/^Imagem do formulário (.+)$/i, 'Imagen del formulario $1'],
  [/^Não foi possível configurar o campo "(.+)"\.$/i, 'No se pudo configurar el campo "$1".'],
  [/^respostas-(.+)\.csv$/i, 'respuestas-$1.csv'],
  [/^Pedido de reembolso enviado(.*)\.$/i, 'Solicitud de reembolso enviada$1.'],
  [/^Pedir reembolso · (.+) disponível$/i, 'Solicitar reembolso · $1 disponible'],
  [/^(.+?) copiado\.$/gi, '$1 copiado.'],
  [/O formulário “([^”]+)” deixou de conseguir validar notificações da Eupago\./gi, 'El formulario “$1” ha dejado de validar las notificaciones de Eupago.'],
  [/formulários deixaram de conseguir validar notificações da Eupago\./gi, 'formularios han dejado de validar las notificaciones de Eupago.'],
  [/Aumentar quantidade de/gi, 'Aumentar cantidad de'],
  [/Diminuir quantidade de/gi, 'Disminuir cantidad de'],
  [/Copiar ID/gi, 'Copiar ID'],
  [/Falha ao enviar imagem\. Código:/gi, 'Error al enviar la imagen. Código:'],
  [/Pedir reembolso ·/gi, 'Solicitar reembolso ·'],
  [/Versão/gi, 'Versión'],
  [/palavra-passe/gi, 'contraseña'],
  [/método de pagamento/gi, 'método de pago'],
  [/métodos de pagamento/gi, 'métodos de pago'],
  [/campo de preço/gi, 'campo de precio'],
  [/campo de doação/gi, 'campo de donación'],
  [/formulário público/gi, 'formulario público'],
  [/formulários públicos/gi, 'formularios públicos'],
  [/chave API/gi, 'clave API'],
  [/data de início/gi, 'fecha de inicio'],
  [/data de fim/gi, 'fecha de fin'],
  [/por favor/gi, 'por favor'],
  [/ainda não/gi, 'todavía no'],
  [/com sucesso/gi, 'correctamente'],
  [/de forma simples/gi, 'de forma sencilla'],
  [/de pagamento/gi, 'de pago'],
  [/do formulário/gi, 'del formulario'],
  [/da plataforma/gi, 'de la plataforma'],
  [/do utilizador/gi, 'del usuario'],
  [/para continuar/gi, 'para continuar'],
  [/para avançar/gi, 'para continuar'],
  [/não pode/gi, 'no puede'],
  [/não existem/gi, 'no hay'],
  [/não existe/gi, 'no existe'],
  [/é obrigatória/gi, 'es obligatoria'],
  [/é obrigatório/gi, 'es obligatorio'],
  [/deve ter/gi, 'debe tener'],
];

const wordsEN: Record<string, string> = {
  a:'the', o:'the', as:'the', os:'the', um:'a', uma:'a', uns:'some', umas:'some',
  de:'of', do:'of', da:'of', dos:'of', das:'of', em:'in', no:'in', na:'in', nos:'in', nas:'in',
  para:'for', por:'by', com:'with', sem:'without', e:'and', ou:'or', mas:'but', se:'if', que:'that',
  não:'not', sim:'yes', este:'this', esta:'this', estes:'these', estas:'these', seu:'your', sua:'your', seus:'your', suas:'your',
  formulário:'form', formulários:'forms', utilizador:'user', utilizadores:'users', cliente:'customer', clientes:'customers',
  empresa:'company', equipa:'team', conta:'account', contas:'accounts', dados:'data', informação:'information', informações:'information',
  pagamento:'payment', pagamentos:'payments', resposta:'reply', respostas:'replies', campo:'field', campos:'fields',
  nome:'name', email:'email', estado:'status', ações:'actions', ação:'action', criar:'create', criado:'created', criada:'created',
  editar:'edit', guardar:'save', eliminar:'delete', apagar:'delete', remover:'remove', adicionar:'add', selecionar:'select',
  escolher:'choose', escolha:'choice', pesquisar:'search', procurar:'search', voltar:'back', seguinte:'next', anterior:'previous',
  finalizar:'finish', confirmar:'confirm', configuração:'configuration', configurações:'settings', definições:'settings',
  idioma:'language', português:'Portuguese', espanhol:'Spanish', inglês:'English', automático:'automatic', browser:'browser',
  localização:'location', ligação:'link', data:'date', início:'start', fim:'end', prazo:'deadline', valor:'value', valores:'values',
  quantidade:'quantity', quantidades:'quantities', máximo:'maximum', máxima:'maximum', stock:'stock', disponível:'available',
  referência:'reference', entidade:'entity', notificação:'notification', notificações:'notifications', mensagem:'message', mensagens:'messages',
  erro:'error', erros:'errors', sucesso:'success', atenção:'attention', necessário:'required', necessária:'required',
  obrigatório:'required', obrigatória:'required', opcional:'optional', ativo:'active', ativa:'active', inativo:'inactive', inativa:'inactive',
  pendente:'pending', pago:'paid', concluído:'completed', sincronizado:'synchronized', sincronização:'synchronization',
  segurança:'security', acesso:'access', gestão:'management', administrar:'manage', perfil:'profile', função:'role', responsável:'owner',
  imagem:'image', imagens:'images', ficheiro:'file', ficheiros:'files', carregar:'load', carregamento:'loading', enviar:'send', enviado:'sent',
  partilhar:'share', publicação:'publishing', publicado:'published', público:'public', pública:'public',
  texto:'text', título:'title', comentário:'comment', seleção:'selection', validação:'validation', avaliação:'rating',
  preço:'price', doação:'donation', donativo:'donation', dinheiro:'cash', numerário:'cash', cartão:'card', crédito:'credit',
  telefone:'phone', número:'number', país:'country', indicativo:'calling code',
  novo:'new', nova:'new', novos:'new', novas:'new', todos:'all', todas:'all', nenhum:'none', nenhuma:'none',
  ainda:'still', já:'already', agora:'now', depois:'after', antes:'before', sempre:'always', apenas:'only', também:'also',
  pode:'can', podes:'can', poderá:'can', deve:'must', devem:'must', será:'will be', serão:'will be',
  foi:'was', foram:'were', é:'is', são:'are', está:'is', estão:'are', fica:'becomes', ficam:'become',
  preenche:'fill', preencher:'fill', preenchido:'filled', preenchida:'filled', escolhe:'choose',
  introduza:'enter', insira:'enter', confirme:'confirm', verifica:'check', alterar:'change', atualizado:'updated', atualizada:'updated',
  indisponível:'unavailable', simples:'simple', rápido:'fast', rápida:'fast', seguro:'secure', segura:'secure',
  melhor:'better', principal:'main', principais:'main', geral:'general', total:'total', livre:'free', manual:'manual',
  descrição:'description', regras:'rules', regra:'rule', opção:'option', opções:'options', tipo:'type', tipos:'types',
};

const wordsES: Record<string, string> = {
  a:'la', o:'el', as:'las', os:'los', um:'un', uma:'una', uns:'unos', umas:'unas',
  de:'de', do:'del', da:'de la', dos:'de los', das:'de las', em:'en', no:'en el', na:'en la', nos:'en los', nas:'en las',
  para:'para', por:'por', com:'con', sem:'sin', e:'y', ou:'o', mas:'pero', se:'si', que:'que',
  não:'no', sim:'sí', este:'este', esta:'esta', estes:'estos', estas:'estas', seu:'su', sua:'su', seus:'sus', suas:'sus',
  formulário:'formulario', formulários:'formularios', utilizador:'usuario', utilizadores:'usuarios', cliente:'cliente', clientes:'clientes',
  empresa:'empresa', equipa:'equipo', conta:'cuenta', contas:'cuentas', dados:'datos', informação:'información', informações:'información',
  pagamento:'pago', pagamentos:'pagos', resposta:'respuesta', respostas:'respuestas', campo:'campo', campos:'campos',
  nome:'nombre', email:'email', estado:'estado', ações:'acciones', ação:'acción', criar:'crear', criado:'creado', criada:'creada',
  editar:'editar', guardar:'guardar', eliminar:'eliminar', apagar:'eliminar', remover:'eliminar', adicionar:'añadir', selecionar:'seleccionar',
  escolher:'elegir', escolha:'elección', pesquisar:'buscar', procurar:'buscar', voltar:'volver', seguinte:'siguiente', anterior:'anterior',
  finalizar:'finalizar', confirmar:'confirmar', configuração:'configuración', configurações:'configuraciones', definições:'configuración',
  idioma:'idioma', português:'portugués', espanhol:'español', inglês:'inglés', automático:'automático', browser:'navegador',
  localização:'ubicación', ligação:'enlace', data:'fecha', início:'inicio', fim:'fin', prazo:'plazo', valor:'valor', valores:'valores',
  quantidade:'cantidad', quantidades:'cantidades', máximo:'máximo', máxima:'máxima', stock:'stock', disponível:'disponible',
  referência:'referencia', entidade:'entidad', notificação:'notificación', notificações:'notificaciones', mensagem:'mensaje', mensagens:'mensajes',
  erro:'error', erros:'errores', sucesso:'éxito', atenção:'atención', necessário:'necesario', necessária:'necesaria',
  obrigatório:'obligatorio', obrigatória:'obligatoria', opcional:'opcional', ativo:'activo', ativa:'activa', inativo:'inactivo', inativa:'inactiva',
  pendente:'pendiente', pago:'pagado', concluído:'completado', sincronizado:'sincronizado', sincronização:'sincronización',
  segurança:'seguridad', acesso:'acceso', gestão:'gestión', administrar:'gestionar', perfil:'perfil', função:'función', responsável:'responsable',
  imagem:'imagen', imagens:'imágenes', ficheiro:'archivo', ficheiros:'archivos', carregar:'cargar', carregamento:'carga', enviar:'enviar', enviado:'enviado',
  partilhar:'compartir', publicação:'publicación', publicado:'publicado', público:'público', pública:'pública',
  texto:'texto', título:'título', comentário:'comentario', seleção:'selección', validação:'validación', avaliação:'valoración',
  preço:'precio', doação:'donación', donativo:'donación', dinheiro:'efectivo', numerário:'efectivo', cartão:'tarjeta', crédito:'crédito',
  telefone:'teléfono', número:'número', país:'país', indicativo:'prefijo',
  novo:'nuevo', nova:'nueva', novos:'nuevos', novas:'nuevas', todos:'todos', todas:'todas', nenhum:'ninguno', nenhuma:'ninguna',
  ainda:'todavía', já:'ya', agora:'ahora', depois:'después', antes:'antes', sempre:'siempre', apenas:'solo', também:'también',
  pode:'puede', podes:'puedes', poderá:'podrá', deve:'debe', devem:'deben', será:'será', serão:'serán',
  foi:'fue', foram:'fueron', é:'es', são:'son', está:'está', estão:'están', fica:'queda', ficam:'quedan',
  preenche:'completa', preencher:'completar', preenchido:'completado', preenchida:'completada', escolhe:'elige',
  introduza:'introduzca', insira:'introduzca', confirme:'confirme', verifica:'comprueba', alterar:'cambiar', atualizado:'actualizado', atualizada:'actualizada',
  indisponível:'no disponible', simples:'sencillo', rápido:'rápido', rápida:'rápida', seguro:'seguro', segura:'segura',
  melhor:'mejor', principal:'principal', principais:'principales', geral:'general', total:'total', livre:'libre', manual:'manual',
  descrição:'descripción', regras:'reglas', regra:'regla', opção:'opción', opções:'opciones', tipo:'tipo', tipos:'tipos',
};


const extraWordsEN: Record<string, string> = {
  possível:'possible', elemento:'element', elementos:'elements', legenda:'label', como:'as', pelo:'by', pela:'by',
  novamente:'again', gerir:'manage', administrador:'administrator', usa:'uses', usar:'use', tem:'has', crie:'create',
  exemplo:'example', visualização:'preview', plataforma:'platform', aqui:'here', menos:'less', pedido:'request', válido:'valid',
  válida:'valid', alterações:'changes', alteração:'change', exibido:'displayed', exibida:'displayed', ver:'view', ter:'have',
  minha:'my', meu:'my', favor:'please', inscrição:'registration', conteúdo:'content', subtítulo:'subtitle', consulte:'view',
  guardado:'saved', guardada:'stored', guardados:'stored', guardadas:'stored', palavras:'words', atual:'current', tente:'try',
  lista:'list', tenta:'tries', aparece:'appears', aparecem:'appear', ajuda:'help', deste:'this', desta:'this',
  acompanhe:'track', acompanhar:'track', fechar:'close', mostrar:'show', evento:'event', eventos:'events', local:'location',
  coincidem:'match', automaticamente:'automatically', removido:'removed', removida:'removed', modelo:'template', atualizar:'update',
  contacto:'contact', página:'page', funciona:'works', dentro:'inside', associado:'associated', associada:'associated',
  associados:'associated', associadas:'associated', múltipla:'multiple', linha:'line', adicione:'add', coordenadas:'coordinates',
  mapa:'map', alterada:'changed', alterado:'changed', abrir:'open', entrar:'sign in', primeiro:'first', primeira:'first',
  abaixo:'below', visual:'visual', teu:'your', tua:'your', ordenar:'sort', define:'defines', quando:'when', tudo:'everything',
  práticas:'practices', vantagens:'benefits', sair:'sign out', rótulo:'label', conhecimento:'acknowledgement',
  obrigatoriamente:'necessarily', nif:'tax number', altere:'change', lugar:'place', visualizar:'view', divisão:'divider',
  pesquisa:'search', aceita:'accepts', parágrafo:'paragraph', mantenha:'keep', entre:'between', preencha:'fill',
  preencher:'fill', ocultar:'hide', publique:'publish', canal:'channel', sincronizar:'synchronize', ideal:'ideal',
  donativos:'donations', área:'area', adiciona:'adds', avançar:'continue', cada:'each', evita:'avoids', começar:'start',
  pronto:'ready', produto:'product', marca:'brand', secção:'section', duplicar:'duplicate', itens:'items', forma:'way',
  pendentes:'pending', fazer:'do', tomei:'acknowledge', constante:'contained', tratada:'processed', tratado:'processed',
  dou:'give', consentimento:'consent', tal:'so', valida:'validates', pausa:'pause', encontrado:'found', encontrada:'found',
  limite:'limit', ativos:'active', ativas:'active', definir:'define', utilize:'use', maiúscula:'uppercase', mais:'more',
  certeza:'sure', quer:'want', trabalho:'work', clara:'clear', claro:'clear', construir:'build', importa:'matters',
  faça:'do', facilmente:'easily', rapidamente:'quickly', melhor:'better', melhores:'better', receber:'receive', recebidas:'received',
  recebido:'received', recebemos:'we received', obtida:'obtained', obtido:'obtained', fornecidas:'provided', fornecidos:'provided',
  selecionado:'selected', selecionada:'selected', selecionados:'selected', fornecida:'provided', existente:'existing',
  confiança:'trust', ideia:'idea', experiência:'experience', centralizada:'centralized',
  precisa:'need', precisam:'need', horas:'hours', solução:'solution', partilhe:'share', processo:'process',
  connosco:'with us', disponibilizado:'available', calendário:'calendar',
  sugestivo:'suggestive', antes:'before', escrever:'write', apresentado:'shown', apresentada:'shown', principal:'main',
  secundário:'secondary', secundária:'secondary', instruções:'instructions', blocos:'blocks', livre:'free', cobrado:'charged',
  cobrada:'charged', separador:'separator', decimal:'decimal', marcado:'checked', partilha:'share', única:'unique', único:'unique',
  endereço:'address', atividade:'activity', aceda:'access', principais:'main', áreas:'areas', controle:'control', permissões:'permissions',
  pessoas:'people', acesso:'access', inteira:'entire', toda:'all', todos:'all', protegido:'protected', protegida:'protected',
  fotografia:'photo', exceder:'exceed', caracteres:'characters', letra:'letter',
  algarismos:'digits', italiano:'Italian', italiana:'Italian', recolher:'collect', contributos:'contributions', comerciais:'commercial',
};

const extraWordsES: Record<string, string> = {
  possível:'posible', elemento:'elemento', elementos:'elementos', legenda:'etiqueta', como:'como', pelo:'por', pela:'por',
  novamente:'de nuevo', gerir:'gestionar', administrador:'administrador', usa:'usa', usar:'usar', tem:'tiene', crie:'cree',
  exemplo:'ejemplo', visualização:'vista previa', plataforma:'plataforma', aqui:'aquí', menos:'menos', pedido:'solicitud', válido:'válido',
  válida:'válida', alterações:'cambios', alteração:'cambio', exibido:'mostrado', exibida:'mostrada', ver:'ver', ter:'tener',
  minha:'mi', meu:'mi', favor:'favor', inscrição:'inscripción', conteúdo:'contenido', subtítulo:'subtítulo', consulte:'consulte',
  guardado:'guardado', guardada:'guardada', guardados:'guardados', guardadas:'guardadas', palavras:'palabras', atual:'actual', tente:'intente',
  lista:'lista', tenta:'intenta', aparece:'aparece', aparecem:'aparecen', ajuda:'ayuda', deste:'de este', desta:'de esta',
  acompanhe:'siga', acompanhar:'seguir', fechar:'cerrar', mostrar:'mostrar', evento:'evento', eventos:'eventos', local:'ubicación',
  coincidem:'coinciden', automaticamente:'automáticamente', removido:'eliminado', removida:'eliminada', modelo:'plantilla', atualizar:'actualizar',
  contacto:'contacto', página:'página', funciona:'funciona', dentro:'dentro', associado:'asociado', associada:'asociada',
  associados:'asociados', associadas:'asociadas', múltipla:'múltiple', linha:'línea', adicione:'añada', coordenadas:'coordenadas',
  mapa:'mapa', alterada:'cambiada', alterado:'cambiado', abrir:'abrir', entrar:'entrar', primeiro:'primero', primeira:'primera',
  abaixo:'debajo', visual:'visual', teu:'tu', tua:'tu', ordenar:'ordenar', define:'define', quando:'cuando', tudo:'todo',
  práticas:'prácticas', vantagens:'ventajas', sair:'cerrar sesión', rótulo:'etiqueta', conhecimento:'conocimiento',
  obrigatoriamente:'obligatoriamente', nif:'NIF', altere:'cambie', lugar:'lugar', visualizar:'ver', divisão:'divisor',
  pesquisa:'búsqueda', aceita:'acepta', parágrafo:'párrafo', mantenha:'mantenga', entre:'entre', preencha:'complete',
  preencher:'completar', ocultar:'ocultar', publique:'publique', canal:'canal', sincronizar:'sincronizar', ideal:'ideal',
  donativos:'donaciones', área:'área', adiciona:'añade', avançar:'continuar', cada:'cada', evita:'evita', começar:'empezar',
  pronto:'listo', produto:'producto', marca:'marca', secção:'sección', duplicar:'duplicar', itens:'elementos', forma:'forma',
  pendentes:'pendientes', fazer:'hacer', tomei:'reconozco', constante:'contenida', tratada:'tratada', tratado:'tratado',
  dou:'doy', consentimento:'consentimiento', tal:'ello', valida:'valida', pausa:'pausa', encontrado:'encontrado', encontrada:'encontrada',
  limite:'límite', ativos:'activos', ativas:'activas', definir:'definir', utilize:'utilice', maiúscula:'mayúscula', mais:'más',
  certeza:'seguridad', quer:'quiere', trabalho:'trabajo', clara:'clara', claro:'claro', construir:'construir', importa:'importa',
  faça:'haga', facilmente:'fácilmente', rapidamente:'rápidamente', melhores:'mejores', receber:'recibir', recebidas:'recibidas',
  recebido:'recibido', recebemos:'recibimos', obtida:'obtenida', obtido:'obtenido', fornecidas:'proporcionadas', fornecidos:'proporcionados',
  selecionado:'seleccionado', selecionada:'seleccionada', selecionados:'seleccionados', fornecida:'proporcionada', existente:'existente',
  confiança:'confianza', ideia:'idea', experiência:'experiencia', centralizada:'centralizada', precisa:'necesita', precisam:'necesitan',
  horas:'horas', solução:'solución', partilhe:'comparta', processo:'proceso', connosco:'con nosotros', disponibilizado:'disponible',
  calendário:'calendario', sugestivo:'sugerente', escrever:'escribir', apresentado:'mostrado', apresentada:'mostrada',
  secundário:'secundario', secundária:'secundaria', instruções:'instrucciones', blocos:'bloques', cobrado:'cobrado', cobrada:'cobrada',
  separador:'separador', decimal:'decimal', marcado:'marcado', única:'única', único:'único', endereço:'dirección', atividade:'actividad',
  aceda:'acceda', áreas:'áreas', controle:'controle', permissões:'permisos', pessoas:'personas', inteiro:'entero', inteira:'entera',
  protegido:'protegido', protegida:'protegida', fotografia:'foto', exceder:'superar', caracteres:'caracteres', letra:'letra',
  algarismos:'dígitos', italiano:'italiano', italiana:'italiana', recolher:'recoger', contributos:'aportaciones', comerciais:'comerciales',
};


const finalWordsEN: Record<string, string> = {
  à:'to the', às:'to the', só:'only', pré:'pre', débitos:'debits', método:'method', métodos:'methods', começa:'starts',
  cabeçalho:'header', identificação:'identification', visível:'visible', referências:'references', câmara:'camera', ficará:'will become',
  rápidos:'fast', integrações:'integrations', criptográfica:'cryptographic', inscrições:'registrations', lápis:'pencil', confirmação:'confirmation',
  introdução:'introduction', pôde:'could', através:'through', complicações:'complications', próximo:'next', código:'code', títulos:'titles',
  recém:'recently', edição:'editing', últimos:'latest', responsáveis:'owners', submissões:'submissions', deixa:'stops', até:'until',
  terá:'will have', obrigatórios:'required', deixará:'will stop', produção:'production', disponíveis:'available', indisponíveis:'unavailable',
  formações:'training', útil:'useful', transferência:'transfer', introdutório:'introductory', criação:'creation', constrói:'builds', vê:'see',
  ecrã:'screen', marcação:'booking', aceitação:'acceptance', várias:'several', visíveis:'visible', pontuação:'score', solidário:'charity',
  cópia:'copy', telemóvel:'mobile phone', secções:'sections', avançadas:'advanced', necessários:'required', limitação:'limit',
  finalização:'completion', legível:'readable', logótipo:'logo', esforço:'effort', experiências:'experiences', utilização:'use',
  dimensão:'size', três:'three', desnecessária:'unnecessary', instantânea:'instant', sessão:'session', inválido:'invalid', inválidos:'invalid',
  concluídos:'completed', paginação:'pagination', expressão:'expression', introduções:'introductions', cabeçalhos:'headers', após:'after',
  onde:'where', daí:'therefore', programação:'programming', itália:'Italy', aplicação:'application', ícone:'icon', alterá:'change it',
  estás:'you are', inválidas:'invalid', números:'numbers', numéricos:'numeric', genérica:'generic', telefónico:'phone', numérico:'numeric',
  vírgula:'comma', mantém:'keeps', próximos:'next', orientação:'guidance', data:'date',
};

const finalWordsES: Record<string, string> = {
  à:'a la', às:'a las', só:'solo', pré:'pre', débitos:'débitos', método:'método', métodos:'métodos', começa:'empieza',
  cabeçalho:'encabezado', identificação:'identificación', visível:'visible', referências:'referencias', câmara:'cámara', ficará:'quedará',
  rápidos:'rápidos', integrações:'integraciones', criptográfica:'criptográfica', inscrições:'inscripciones', lápis:'lápiz', confirmação:'confirmación',
  introdução:'introducción', pôde:'pudo', através:'a través', complicações:'complicaciones', próximo:'siguiente', código:'código', títulos:'títulos',
  recém:'recién', edição:'edición', últimos:'últimos', responsáveis:'responsables', submissões:'envíos', deixa:'deja', até:'hasta',
  terá:'tendrá', obrigatórios:'obligatorios', deixará:'dejará', produção:'producción', disponíveis:'disponibles', indisponíveis:'no disponibles',
  formações:'formaciones', útil:'útil', transferência:'transferencia', introdutório:'introductorio', criação:'creación', constrói:'construye', vê:'ve',
  ecrã:'pantalla', marcação:'reserva', aceitação:'aceptación', várias:'varias', visíveis:'visibles', pontuação:'puntuación', solidário:'solidario',
  cópia:'copia', telemóvel:'móvil', secções:'secciones', avançadas:'avanzadas', necessários:'necesarios', limitação:'limitación',
  finalização:'finalización', legível:'legible', logótipo:'logotipo', esforço:'esfuerzo', experiências:'experiencias', utilização:'uso',
  dimensão:'tamaño', três:'tres', desnecessária:'innecesaria', instantânea:'instantánea', sessão:'sesión', inválido:'inválido', inválidos:'inválidos',
  concluídos:'completados', paginação:'paginación', expressão:'expresión', introduções:'introducciones', cabeçalhos:'encabezados', após:'después',
  onde:'donde', daí:'por tanto', programação:'programación', itália:'Italia', aplicação:'aplicación', ícone:'icono', alterá:'cambiarlo',
  estás:'estás', inválidas:'inválidas', números:'números', numéricos:'numéricos', genérica:'genérica', telefónico:'telefónico', numérico:'numérico',
  vírgula:'coma', mantém:'mantiene', próximos:'siguientes', orientação:'orientación', data:'fecha',
};

const preserveCase = (source: string, replacement: string) => {
  if (!source) return replacement;
  if (source === source.toUpperCase() && source.length > 1) return replacement.toUpperCase();
  if (source[0] === source[0].toUpperCase()) {
    return replacement.charAt(0).toUpperCase() + replacement.slice(1);
  }
  return replacement;
};

const shouldSkip = (trimmed: string) => {
  if (!trimmed) return true;
  if (/^https?:\/\//i.test(trimmed)) return true;
  if (/^[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(trimmed)) return true;
  if (/^[+\d\s.,€$%:/()-]+$/.test(trimmed)) return true;
  if (/^[A-Fa-f0-9-]{20,}$/.test(trimmed)) return true;
  return false;
};

export const translateUiText = (value: string, language: UiLanguage): string => {
  if (value == null) return value;

  const leading = value.match(/^\s*/)?.[0] ?? '';
  const trailing = value.match(/\s*$/)?.[0] ?? '';
  const trimmed = value.trim();
  if (shouldSkip(trimmed)) return value;

  if (language === 'PT') {
    const translated = exactPT[trimmed];
    return translated ? `${leading}${translated}${trailing}` : value;
  }

  const exact = language === 'EN' ? exactEN : exactES;
  if (exact[trimmed]) return `${leading}${exact[trimmed]}${trailing}`;

  let translated = trimmed;
  const phrases = language === 'EN' ? phraseEN : phraseES;
  for (const [pattern, replacement] of phrases) {
    translated = translated.replace(pattern, replacement);
  }

  // Do not translate unknown text word-by-word. The DOM contains form names,
  // customer-entered labels, URLs and technical values that must never be mangled.
  // Unknown strings are preserved unless one of the explicit dynamic phrase rules
  // above matched them.
  if (translated === trimmed) return value;

  return `${leading}${translated}${trailing}`;
};
